/* Ring builder — per-step page controllers.
   One file, dispatched on <div class="rb" data-rb-page="...">, so the theme only
   has to register one script. Depends on ring-builder.js (RingBuilder). */
(function () {
  'use strict';
  var RB = window.RingBuilder;
  if (!RB) return;
  var el = RB.el, money = RB.money;

  // A preview with NO frame is the engine's fixed-photo ring with no photograph of the metal shown (Codex
  // review-muunbcfe-4za78s, finding 1): the stage draws only its caption, the "Preview unavailable." words it already
  // shows when a picture fails to load, never another metal's photograph. The mark tells the engine this copy can.
  RB.stageShowsUnavailable = true;
  function earringStage(stage, controls, preview) {
    controls.innerHTML = '';
    if (!preview.frames.length) {
      controls.appendChild(el('p', {class: 'rb-earring-caption', text: preview.caption}));
      return;
    }
    var picture = el('img', {src: preview.frames[0].url, alt: preview.caption, class: 'on'});
    picture.addEventListener('error', function () {
      picture.hidden = true;
      note.textContent = 'Preview unavailable. Please try another view.';
    });
    stage.appendChild(picture);
    preview.frames.forEach(function (frame, index) {
      var button = el('button', {type: 'button', class: 'rb-angle rb-angle--earring',
        'aria-pressed': String(index === 0), text: frame.label});
      button.addEventListener('click', function () {
        picture.hidden = false;
        note.textContent = preview.caption;
        picture.src = frame.url;
        controls.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === button));
        });
      });
      controls.appendChild(button);
    });
    var note = el('p', {class: 'rb-earring-caption', text: preview.caption});
    controls.appendChild(note);
  }

  /* 🚨 THE PHOTOGRAPH OF THE METAL SHOWN, NEVER ANOTHER METAL'S (owner 2026-10-05; Codex reviews muunbcfe-4za78s and
     muup0ncp-mku32c). The review page drew `setting.img`, the main photograph, whatever the metal: on the 60 pendant
     designs with no render that put white gold, rose gold and platinum under the yellow gold photograph (140 choices,
     2026-10-05). Every offered metal has a photograph of its own (the owner: "we should be able to provide a photo";
     audit_builder_metal_photos.py names any that is missing, and missing-metal-photos/ makes it in the right metal), so a
     null here is a photograph still being made: the caller draws the "Preview unavailable." state, never the main photo.
     The default metal is RB.settingThumb's. No metal at all (none offered) is the main photograph, which names none. */
  function ownPhoto(s, metal) {
    if (!s) return null;
    var m = metal || (s.metals && s.metals.indexOf('14K Yellow Gold') >= 0 ? '14K Yellow Gold' : (s.metals || [])[0]);
    return m ? ((s.imgByMetal || {})[m] || null) : (s.img || null);
  }
  var UNAVAILABLE = {frames: [], caption: 'Preview unavailable.'};

  // PEARL leads because it is not a cut — a pearl seat takes a pearl and nothing
  // else, and a pearl shopper should not have to hunt past ten diamond cuts.
  // Without it in this list the rail rendered no Pearl entry at all, so the 84
  // pearl pendant settings landed the shopper on an empty grid (owner rule
  // 2026-07-29: only HALF-drilled pearls are offered — a cup or peg needs one).
  var SHAPE_ORDER = ['PEARL', 'ROUND', 'OVAL', 'CUSHION', 'EMERALD', 'PEAR', 'RADIANT',
    'SQUARE', 'ASSCHER', 'MARQUISE', 'HEART', 'ELONGATED CUSHION',
    'ANTIQUE CUSHION', 'TRILLION', 'ELONGATED HEXAGON', 'OCTAGON',
    'ELONGATED OVAL', 'STRAIGHT BAGUETTE'];

  // A pearl is graded on nothing the diamond rail asks about — no carat, colour,
  // clarity or cut. Those filters would sit there matching everything (or nothing)
  // and the card subtitle "1.27 ct · F · VVS1 · Excellent" would render as a row
  // of empty separators. Owner decision 2026-07-29.
  var isPearlBuild = function (build) {
    return String((build && build.seat) || '').indexOf('PEARL|') === 0;
  };
  var title = function (s) {
    return String(s || '').toLowerCase().replace(/(^|\s)\w/g, function (m) { return m.toUpperCase(); });
  };
  // "a emerald center", "a asscher", "a oval". Five of the eighteen shapes start
  // with a vowel, so the count line got this wrong nearly a third of the time.
  var article = function (word) {
    return /^[aeiou]/i.test(String(word || '')) ? 'an' : 'a';
  };

  /* A CONFIGURATION GROUP IS NOT COLLAPSIBLE (owner, 2026-09-02: "There shouldn't
     be the toggle to hide elements, they are redundant"). This used to render the
     label as a collapsible button with a chevron and an open/closed state, the way
     the old filter rail did. On this page the groups are the VARIANT PICKERS —
     shape, size, metal, accents — and hiding one hides the thing being bought, so
     every caller opened it and the toggle only ever offered a way to make the page
     worse. It is a plain label over an always-visible body now, which is also how
     the product page draws its "Metal:" group.
     ⚠️ `facet()` in ring-builder-stones.js is a DIFFERENT function (it delegates to
     RB.panelRow) and was never collapsible either; nothing shares this one. */
  var facetSeq = 0;
  function facet(name, body, value) {
    // The label was a <button>, which a screen reader reached; a plain <div> is
    // skipped, so the chips underneath read as "Round, button" with no group named
    // (Codex, 2026-09-02). `role="group"` + `aria-labelledby` on the NAME span gives
    // the pickers back the name without a <fieldset>'s UA styling to fight.
    var id = 'rb-facet-' + (++facetSeq) + '-' +
      String(name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    var f = el('div', { class: 'rb-facet', role: 'group', 'aria-labelledby': id });
    // "Metal: 14K Yellow Gold" — the label at 600 and the chosen value at 400, which
    // is the product page's own `.form__label` + `.form__label-value` pairing.
    f.appendChild(el('div', { class: 'rb-facet__title' }, [
      el('span', { id: id, text: name + (value ? ': ' : '') }),
      value ? el('span', { class: 'rb-facet__val', text: value }) : null
    ]));
    f.appendChild(el('div', { class: 'rb-facet__body' }, body));
    return f;
  }

  /* 🚨 THE HAND-DRAWN `SHAPE_SVG` TABLE THAT USED TO LIVE HERE IS GONE (2026-08-12).
     It was an 18-entry set of one-off SVG paths, and it was the reason a round in
     the builder and a round on /collections/sapphires were two different drawings —
     the owner reported exactly that ("shapes, colors, etc. should be consistent").
     `snippets/gem-shape-icon.liquid` is the store's canonical set; the builder now
     clones it out of the sprite rendered by sections/ring-builder.liquid, via
     `RB.shapeArt`.

     ⚠️ DO NOT REINSTATE A LOCAL FALLBACK SET. The old table quietly resolved every
     unknown shape to `SHAPE_SVG.ROUND`, so a shape it had never heard of rendered
     as a circle and looked deliberate — a marquise filter drawn as a round. A
     missing icon now yields an empty art box beside a correct label, which is
     legible as "no icon" rather than as the wrong stone. */

  var METAL_SWATCH = {
    '14K Yellow Gold': '#f3dc9a',
    '14K White Gold': '#f6f6f6',
    '14K Rose Gold': '#f4cfc0',
    'Platinum': '#f6f6f6'
  };
  /* TWO-TONE METALS (owner 2026-09-25). Named in the supplier's order — the FIRST colour is the band, the second
     holds the stone — and drawn as a split disc of the two single-metal swatches above (band top-left, head
     bottom-right). The regex stays local, not RB.twoTone, so this file works beside an older ring-builder.js while a
     release's two files settle in caches. Order and names: builder_metals.TWO_TONE (test_two_tone.py). */
  var TWO_TONE_METALS = ['14K Yellow & White Gold', '14K White & Yellow Gold', '14K Rose & White Gold',
                         '14K White & Rose Gold', '14K Yellow & Rose Gold', '14K Rose & Yellow Gold'];
  var TWO_TONE_RE = /^\d{2}K (Yellow|White|Rose) & (Yellow|White|Rose) Gold$/;
  function metalSwatch(m) {
    var tt = TWO_TONE_RE.exec(m || '');
    if (!tt) {
      var c = METAL_SWATCH[(m || '').replace(/^(10|18)K /, '14K ')];
      return c ? 'linear-gradient(' + c + ',' + c + ')' : undefined;
    }
    var a = METAL_SWATCH['14K ' + tt[1] + ' Gold'], b = METAL_SWATCH['14K ' + tt[2] + ' Gold'];
    return 'linear-gradient(135deg,' + a + ' 50%,' + b + ' 50%)';
  }

  // `tileGroup` (a 4-column `.rb-chipgrid` of icon tiles) was removed with
  // SHAPE_SVG on 2026-08-12 — the filter panel's tiles are `RB.shapeTile` /
  // `RB.swatchTile` now, which are the species pages' own. `chipGroup` below is a
  // different control and stays: it is the word-pill variant picker on the setting
  // DETAIL step, which is a configuration, not a filter.

  // 🚨 THE WRAPPER IS THE WHOLE POINT — it used to return BARE BUTTONS.
  // `.rb-facet__body` is a plain block, so a loose list of buttons stacked ONE PER
  // LINE. On a straight-baguette pendant that meant 10 shape rows + 13 size rows +
  // 4 metal rows down a single column, and the options panel ran several screens
  // past the photograph beside it (owner, 2026-08-05: "very vertical").
  //
  // `.rb-chiprow` flows them like the made-to-order product pages' variant picker,
  // which is what the owner asked these to match: a flex row that wraps, pills
  // sized to their own text. Measured off `.variant-picker` on a live product page
  // rather than guessed — see the CSS.
  //
  // ⚠️ NOT `.rb-chipgrid`, which is the OTHER chip layout in this file. That one is
  // a fixed 4-column grid of icon TILES (see tileGroup, used by the settings rail
  // and the stone browser) and it exists so silhouettes line up in even columns.
  // Forcing word-pills of wildly different widths — "Round" beside "Straight
  // Baguette" — into equal columns is what makes a grid look broken.
  // `why` (M147, 2026-09-25): the reason a grayed chip is grayed, on hover, the way the
  // gemstone grid's grayed shape tiles carry theirs. Callers that pass none are unchanged.
  function chipGroup(values, selected, onPick, labelFor, disabledSet, why) {
    return [el('div', { class: 'rb-chiprow' }, values.map(function (v) {
      return el('button', {
        class: 'rb-chip', type: 'button',
        'aria-pressed': String(selected === v),
        disabled: disabledSet && disabledSet.has(v) ? 'disabled' : null,
        title: why && disabledSet && disabledSet.has(v) ? why : null,
        text: labelFor ? labelFor(v) : v,
        onclick: function () { onPick(selected === v ? null : v); }
      });
    }))];
  }

  /* ========================================= STEP 1b — setting detail ---- */
  // Same URL as the grid with view=detail, so back/forward works and the address
  // stays shareable. This is where the customer commits to metal, center-stone
  // shape/size and accent origin — i.e. picks the actual Shopify variant.
  function pageSettingDetail(root, build, style) {
    var body = root.querySelector('[data-rb-body]');
    body.innerHTML = '<div class="rb-skel" style="grid-column:1/-1;max-width:40rem"></div>';
    // variants + renders are lazy; wait for them before drawing anything that
    // depends on a price or an angle
    // a ring design's accent stone menu too (colored pavé, owner option 1, 2026-11-03): it resolves for every design
    RB.needSettingDetail(build).then(function () {
      return (RB.kind(build) === 'ring' && typeof RB.loadAccentMenu === 'function') ? RB.loadAccentMenu(style) : null;
    }).then(function () { drawSettingDetail(root, build, style); });
  }

  /* ---- THE ACCENT STONES STEP (colored pavé, the full menu; owner option 1, 2026-11-03) ----------------------------
     One stone line for every accent seat, chosen in three rows the way the gemstone search reads: Natural or Lab-grown,
     then the stone (the gem search's own colour swatches, RB.swatchTile, each with the price it adds), then its cut and
     grade only where more than one is offered. A first press on a stone takes its faceted AA line where there is one
     (the plan's default), else its first. The design's diamond accents stay one press away at the top. Every press is
     a link-like go(), so the URL carries the choice and the render on the left redraws in the stone's material. */
  function accentPicker(chosen, opts, acc, accent, s, q, go) {
    var diamonds = s.accents.filter(function (a) { return !RB.accentCurve(a); });
    var dLabel = function (a) { return (a === 'Natural' || a === 'Lab-Grown') ? a + ' Diamond' : a; };
    var wrap = el('div', { class: 'rb-accentpick' });
    wrap.appendChild(el('p', { class: 'rb-facet__hint', text: 'One stone for every accent seat, halo and band. ' +
      'Diamond accents are included with the setting; gemstone accents add the price shown.' }));
    wrap.appendChild(facet('Diamond accents', chipGroup(diamonds, acc ? null : accent,
      function (v) { if (v) go({ accent: v, accentStone: null }); }, dLabel), acc ? null : dLabel(accent)));

    /* The Natural / Lab-grown row BROWSES: a press shows that origin's stones and keeps the chosen stone until another
       is pressed (Codex review-mw0pcx8i-yrucze: the chosen stone's origin used to win, so the press did nothing).
       A stone press clears aorigin, so its own origin shows again. */
    var origins = ['nat', 'lab'].filter(function (o) { return opts.some(function (x) { return x.origin === o; }); });
    var origin = origins.indexOf(q.get('aorigin')) >= 0 ? q.get('aorigin')
               : acc ? acc.origin : origins.indexOf(chosen.origin) >= 0 ? chosen.origin : origins[0];
    var oWord = { nat: 'Natural', lab: 'Lab-grown' };
    wrap.appendChild(facet('Gemstone accents', chipGroup(origins, origin,
      function (v) { if (v) go({ aorigin: v }); }, function (o) { return oWord[o]; }), oWord[origin]));

    // the stones of this origin, one swatch per species and colour, each at the least it adds
    var mine = opts.filter(function (x) { return x.origin === origin; });
    var groups = {}, order = [];
    mine.forEach(function (x) {
      var k = x.colour + ' ' + x.species;
      if (!groups[k]) { groups[k] = []; order.push(k); }
      groups[k].push(x);
    });
    order.sort(function (a, b) { return a < b ? -1 : 1; });
    var least = function (xs) { return Math.min.apply(null, xs.map(function (x) { return x.charge; })); };
    var pickDefault = function (xs) {
      var faceted = xs.filter(function (x) { return x.cut === 'Faceted'; });
      var pool = faceted.length ? faceted : xs;
      return pool.filter(function (x) { return x.grade === 'AA'; })[0] ||
             pool.slice().sort(function (a, b) { return a.charge - b.charge; })[0];
    };
    var curKey = acc && acc.origin === origin ? acc.colour + ' ' + acc.species : null;
    wrap.appendChild(facet('Stone', [RB.scroller(order.map(function (k) {
      var c = groups[k][0].colour.toLowerCase();
      return RB.swatchTile({
        label: k, n: '+' + money(least(groups[k])), on: k === curKey,
        cls: 'sb-colour--' + c,
        sw: 'var(--co-' + c + ', linear-gradient(145deg,#d8cfc4,#a89e90))',
        onclick: function () { if (k !== curKey) go({ accentStone: pickDefault(groups[k]).id, aorigin: null }); }
      });
    }))], curKey));

    if (acc) {
      var same = curKey ? groups[curKey] : [];          // browsing the other origin: no cut or grade row for it
      var cuts = [];
      same.forEach(function (x) { if (cuts.indexOf(x.cut) < 0) cuts.push(x.cut); });
      if (cuts.length > 1) {
        wrap.appendChild(facet('Cut', chipGroup(cuts, acc.cut, function (v) {
          if (!v) return;
          var xs = same.filter(function (x) { return x.cut === v; });
          go({ accentStone: (xs.filter(function (x) { return x.grade === acc.grade; })[0] || pickDefault(xs)).id });
        }), acc.cut));
      }
      var grades = same.filter(function (x) { return x.cut === acc.cut; });
      if (grades.length > 1) {
        wrap.appendChild(facet('Grade', chipGroup(grades.map(function (x) { return x.grade; }), acc.grade,
          function (v) {
            var g = grades.filter(function (x) { return x.grade === v; })[0];
            if (g) go({ accentStone: g.id });
          }), acc.grade));
      }
      wrap.appendChild(el('div', { class: 'rb-sidepick' }, [
        el('p', { class: 'rb-sidepick__k', text: 'Your accent stones' }),
        el('p', { class: 'rb-sidepick__t', text: RB.accentName(acc) + ', ' + acc.cut.toLowerCase() + ', ' + acc.grade }),
        el('p', { class: 'rb-sidepick__s', text: [acc.stones + ' stones', '+' + money(acc.charge),
          acc.treatment ? 'Treatment: ' + acc.treatment : null].filter(Boolean).join(' \u00b7 ') })
      ]));
    }
    return wrap;
  }

  function drawSettingDetail(root, build, style) {
    var s = RB.setting(style);
    var body = root.querySelector('[data-rb-body]');
    if (!s) {
      body.innerHTML = '<div class="rb-empty">That setting could not be found. ' +
        '<a href="' + RB.pages.settings + '">Back to settings</a>.</div>';
      return;
    }
    var q = new URLSearchParams(location.search);

    /* ---- THE STONE, WHEN THERE IS ONE, DECIDES THE SHAPE AND THE SEAT --------
       Half the people on this page arrived from a stone product page ("Set this
       stone into a ring") and have already chosen their centre. For them the
       centre-stone shape and size are not questions — they are FACTS about the
       stone in their hand, and offering them as free choices is how a build ends
       up as an Emerald stone in a Round 7.40 mm seat. So a resolved stone pins
       both, and the chips for everything it rules out are DISABLED rather than
       hidden, which is the same thing step 2's shape rail does with the seat. */
    var stone = root.__stone || null;
    var wantsStone = !!build.stone;                 // in the URL, resolved or not
    var stoneSeat = stone ? RB.bestSeat(style, stone) : null;

    var shape = (stoneSeat ? stone.shape : null) ||
      q.get('shape') || (s.shapes.indexOf('ROUND') >= 0 ? 'ROUND' : s.shapes[0]);
    // A shape this style does not offer leaves the size facet empty and no variant
    // resolvable — the grid never produces one, but a hand-edited or shared URL can.
    if (s.shapes.indexOf(shape) < 0) {
      shape = s.shapes.indexOf('ROUND') >= 0 ? 'ROUND' : s.shapes[0];
    }
    // NUMERIC sort. The index ships seats string-sorted, which puts
    // 10/11/13/15 mm before 4.1 mm and reads as broken.
    var seatsFor = s.seats.filter(function (k) { return RB.parseSeat(k).shape === shape; })
      .sort(function (a, b) {
        var pa = RB.parseSeat(a), pb = RB.parseSeat(b);
        return (pa.l - pb.l) || (pa.w - pb.w);
      });
    var seat = q.get('seat');
    if (stoneSeat) {
      // an explicitly chosen seat survives only if the stone actually sits in it;
      // several seats can hold one stone, and the shopper may prefer a looser one
      if (!(seat && seatsFor.indexOf(seat) >= 0 && RB.fits(stone, seat, style))) seat = stoneSeat;
    } else if (seatsFor.indexOf(seat) < 0) {
      // Default to a mid-range seat rather than the smallest — the smallest is
      // usually a 4 mm accent size nobody centers a ring on. The rule moved to
      // RB.defaultSeat because the step-1 TILE now draws this same seat: it is
      // the picture the shopper clicked, and two copies of the rule would open
      // the page on a different ring than the grid promised.
      seat = RB.defaultSeat(style, shape) || seatsFor[0];
    }
    // ⚠️ VALIDATED AGAINST THIS STYLE, not just defaulted when absent. The seat above
    // already does it; metal and accent read the URL blindly, and `accent=None`
    // carried from any of the 457 no-accent styles into one of the 47 that have
    // accents produced a build key that has never existed. See RB.normalizeToStyle.
    var _n = RB.normalizeToStyle(
      { metal: q.get('metal'), accent: q.get('accent') }, s);
    var metal = _n.metal, accent = _n.accent;
    /* 🚨 AND AGAINST THIS SEAT (M147, 2026-09-25; owner 2026-09-27 "3. Yes"). A style's
       lists are the union of its seats, so a pair the style offers can be one this
       center size is not made in; the page pressed it and the shopper met "That
       combination is not available" at review. `RB.validCombo` answers a pair that
       is made, moving ONLY what the page filled in: a value `normalizeToStyle`
       replaced (absent from the address, or not offered by this style), the same
       test as the review step's `_ours`. A value in the address is the SHOPPER's
       (their own chip, or a pair they went on with) and is never switched for
       them: where no made pair keeps it, it stays pressed, its group says it is not
       made at this size, and the price, the picture, the step bar and the button
       carry nothing forward (`unmade`). Every chip writes only its own value, so
       the address stays the record of what the shopper chose.
       Null (table not in, or a cached previous ring-builder.js) changes nothing. */
    var combo = typeof RB.validCombo === 'function'
      ? RB.validCombo(style, seat, metal, accent,
          { metal: _n.metal === q.get('metal'), accent: _n.accent === q.get('accent') }) : null;
    if (combo) { metal = combo.metal; accent = combo.accent; }
    var unmade = !!(combo && combo.unmade);

    function go(patch) {
      var n = new URLSearchParams(location.search);
      n.set('style', style); n.set('configure', '1');
      Object.keys(patch).forEach(function (k) {
        if (patch[k] == null) n.delete(k); else n.set(k, patch[k]);
      });
      location.search = n.toString();
    }

    // 🚨 START FROM `build`, NEVER FROM A FRESH OBJECT. This was five hand-listed
    // keys, so everything ELSE the build carries — `stone` above all, plus
    // `origin` and `size` — was dropped the moment the shopper left this page.
    // The symptom was the whole point of the deep link being undone: you arrive
    // from a stone product page with the stone chosen, pick a mounting, and step 2
    // asks you to choose a gemstone all over again. A build is not five fields;
    // `RB.FIELDS` says what it is, and copying it wholesale is what keeps this
    // honest when a sixth is added.
    var chosen = Object.assign({}, build, {
      style: style, shape: shape, seat: seat, metal: metal, accent: accent
    });
    var sv = RB.settingVariant(chosen);
    /* ACCENT STONES (colored pavé, the full menu; owner option 1, 2026-11-03): the lines this seat and metal offer
       (RB.accentOptions; [] for every design without a menu, so this page reads as before). A chosen line this seat
       and metal do not offer is dropped back to the diamond accents, and the page says so. */
    var accOpts = (RB.kind(build) === 'ring' && typeof RB.accentOptions === 'function')
      ? RB.accentOptions(Object.assign({}, chosen, { accentStone: null })) : [];
    var acc = chosen.accentStone
      ? (accOpts.filter(function (o) { return o.id === chosen.accentStone; })[0] || null) : null;
    var accDropped = !!(chosen.accentStone && !acc);
    if (accDropped) { chosen.accentStone = null; sv = RB.settingVariant(chosen); }
    var forAccent = q.get('for') === 'accent' && accOpts.length > 0;

    // REDRAW THE STEP BAR AGAINST `chosen`, NOT THE RAW URL. The dispatcher drew
    // it from RB.read() before this function existed, and the seat/metal/accent
    // this page DEFAULTS to are not in the URL until something calls go(). So on
    // a freshly opened setting (?style=…&configure=1) step 3 linked to review
    // with no seat, and review answered "Start by choosing a setting" — from a
    // link the shopper had every reason to think was ready.
    // A stone this style cannot hold is dropped from the bar's build for the same
    // reason the CTA below drops it: otherwise the big button says "choose a
    // gemstone" while the bar two inches above still offers "review and add to
    // cart" on the pair we just said is impossible.
    var stepsMount = root.querySelector('[data-rb-steps]');
    if (stepsMount) {
      RB.stepBar(stepsMount,
        (wantsStone && !stoneSeat) ? Object.assign({}, chosen, { stone: null }) : chosen, 'mount',
        unmade ? { unmade: true } : null);        // M147: no price, and no step past this one
    }

    // `--detail` is what wins back the two-column layout that the settings page's
    // `display:block` override takes away — see ring-builder.css.
    body.className = 'rb-layout rb-layout--detail';
    body.innerHTML = '';

    // --- media: the five real angles for THIS seat and metal
    var stage = el('div', { class: 'rb-stage' });
    var thumbs = el('div', { class: 'rb-angles' });
    // Draw the chosen centre in its own colour — but ONLY when this style can
    // actually hold it. `stoneSeat` is null when the stone fits no seat here, and
    // that is the same case the step bar and the CTA already drop the stone for;
    // colouring the render anyway would show a ring we have just said is
    // impossible, in a colour that makes it look ready to buy.
    // M147: no render of a pair this center size is not made in (the stored photo instead)
    var angles = unmade ? [] : RB.anglesFor(style, seat, metal, stoneSeat ? stone : null, null, acc ? acc.id : accent);
    var earring = RB.earringPreview(chosen, stoneSeat ? stone : null);
    if (earring) {
      earringStage(stage, thumbs, earring);
    } else if (angles.length) {
      // The stage is a drag/zoom viewer now, not a stack of images the
      // thumbnails toggle. It owns the <img> elements, the per-angle scale
      // normalisation and the zoom, so the thumbnails only ever ask it to move.
      var markThumb = function (i) {
        thumbs.querySelectorAll('.rb-angle').forEach(function (b, j) {
          b.setAttribute('aria-pressed', String(j === i));
        });
      };
      var viewer = RB.mountAngleViewer(stage, angles, {
        label: RB.settingName(s.title),
        style: style,                  // for RB.styleScale — the pendant framing fix
        onChange: markThumb            // so a drag moves the strip too
      });
      angles.forEach(function (a, i) {
        thumbs.appendChild(el('button', {
          class: 'rb-angle', type: 'button', 'aria-pressed': String(i === 0),
          title: RB.angleLabel(a.angle),
          onclick: function () {
            if (viewer) viewer.show(i); else markThumb(i);
          }
        }, [el('img', { src: a.url, alt: RB.angleLabel(a.angle), loading: 'lazy' })]));
      });
    } else {
      var own = ownPhoto(s, metal);                 // never another metal's photograph (ownPhoto, above)
      if (own) stage.appendChild(el('img', { src: own, alt: s.title, class: 'on' }));
      else earringStage(stage, thumbs, UNAVAILABLE);
    }
    body.appendChild(el('div', {}, [stage, thumbs]));

    /* --- options: THE RIGHT COLUMN IS A PRODUCT PAGE (owner, 2026-09-02: "The photo
       of the rendered ring or pendant can stay the way it is, but on the right side,
       the information should be structured like the product pages"). Same order as
       `.product__info-container` on a made-to-order PDP — breadcrumb · title · intro
       line · price · pickers · CTA · reassurance — with the builder's own parts (the
       chosen gemstone, the side-stone note) in the slots the PDP's sibling toggle and
       product texts occupy. The stage on the left is untouched.
       ⚠️ The pickers stay `.rb-chip` pills, deliberately. The PDP's metal swatches are
       the theme's radio+label markup polished by sr-product-form-polish.liquid, and
       half-adopting that (swatches for metal, pills for shape and size, which have no
       swatch form) would put two picker vocabularies on one screen. The LABELS match
       that snippet's type instead: 1.55rem/600, the value at 400. */
    var panel = el('div', { class: 'rb-pdp' });
    var mountWord = RB.KINDS[RB.kind(build)].mount;
    var pageH1 = root.querySelector('h1');
    panel.appendChild(RB.crumb([
      { href: '/', text: 'Home' },
      // the settings grid is this same page with `configure`/`style` dropped, and
      // its own masthead heading ("Design your ring") is the truthful name for it
      { href: RB.href(RB.pages.settings, build, { style: null, configure: null }),
        text: (pageH1 && pageH1.textContent.trim()) || ('Choose a ' + mountWord) },
      { text: RB.settingName(s.title) }
    ]));
    panel.appendChild(el('h2', { class: 'h2 rb-pdp__title', text: RB.settingName(s.title) }));
    // the card's design line ("4 mm band · 9 center shapes") is the closest thing a
    // mounting has to the PDP's intro sentence, and it is a fact, not new copy
    if (s.note) panel.appendChild(el('p', { class: 'rb-pdp__intro', text: s.note }));
    // M147: no price for a pair this center size is not made in
    if (!unmade) panel.appendChild(el('p', { class: 'rb-pdp__price' }, [
      el('span', { text: sv ? RB.money((sv[1] + (acc ? acc.charge : 0)) * RB.pairQty(build))
                            : 'From ' + RB.money(s.min * RB.pairQty(build)) }),
      // "setting" on a ring, "mounting" on a pendant — the CSS ::after this replaces
      // said "setting" on every wave
      el('span', { class: 'rb-pdp__price-note', text: RB.pairQty(build) > 1 ? (sv && sv[2] ? ' (pair of mountings, backs included)' : ' (pair of mountings)') : acc ? ' (' + mountWord + ' with accent stones)' : ' (' + mountWord + ' only)' })
    ]));

    // Your gemstone, restated on the page that would otherwise look like it forgot
    // it. The shopper who deep-linked here has no other confirmation that the
    // stone travelled with them, and "did it keep my stone?" is exactly the doubt
    // that sends someone back to step 2 to pick it a second time.
    if (stone && stoneSeat) {
      panel.appendChild(el('div', { class: 'rb-chosen' }, [
        // M002: a ~51px chip (.rb-chosen__img, 5.4rem), so the step bar's own 192px
        // thumbnail, never the 800px original
        stone.img ? el('img', { class: 'rb-chosen__img', alt: '', loading: 'lazy', src: RB.thumbUrl(stone.img) }) : null,
        el('span', { class: 'rb-chosen__body' }, [
          el('span', { class: 'rb-chosen__lbl', text: 'Your gemstone' }),
          el('span', { class: 'rb-chosen__title', text: stone.title }),
          el('span', { class: 'rb-chosen__sub', text: money(stone.price * RB.pairQty(build)) + (RB.pairQty(build) > 1 ? ' for two stones' : '') })
        ]),
        el('a', {
          class: 'rb-chosen__change',
          href: RB.href(RB.stonesPage(build),
                        chosen, { stone: null, seat: null }),
          text: 'Change'
        })
      ]));
    }

    if (accDropped) {
      panel.appendChild(el('div', { class: 'rb-note', text: 'The accent stones you chose are not made in ' + metal +
        ' for the ' + RB.seatLabel(seat) + ' center stone, so the diamond accents are shown. ' +
        'You can choose accent stones again.' }));
    }
    /* THE ACCENT STONES STEP (owner 2026-11-03: "it selects a default and there is an option to change ... adding
       another step"): this page with `for=accent`, the ring drawn in the chosen stone's material on the left. */
    if (forAccent) {
      panel.appendChild(accentPicker(chosen, accOpts, acc, accent, s, q, go));
      var _pickSides = RB.sideSeat(style, seat);
      var _toReview = q.get('from') === 'review' || (stoneSeat && !_pickSides);
      var _pickPath = _toReview ? RB.pages.review
        : (stoneSeat && _pickSides) ? RB.sidePage(chosen) : RB.stonesPage(build);
      panel.appendChild(el('a', {
        class: 'btn btn-primary rb-pdp__cta',
        href: RB.href(_pickPath, chosen, { configure: null, from: null, aorigin: null,
          'for': (!_toReview && stoneSeat && _pickSides) ? 'side' : null,
          stone: (wantsStone && !stoneSeat) ? null : (chosen.stone || null) }),
        text: acc ? 'Proceed with these accent stones \u2192' : 'Proceed with diamond accents \u2192'
      }));
      body.appendChild(panel);
      return;
    }

    var shapeChoices = SHAPE_ORDER.filter(function (x) { return s.shapes.indexOf(x) >= 0; });
    var lockedShapes = null;
    if (stoneSeat) {
      // SHAPE_ORDER is a hand-kept list, so a shape it has never heard of is
      // dropped here. Harmless while every chip is live; with everything else
      // disabled it would leave a facet of nothing but greyed-out chips.
      if (shapeChoices.indexOf(stone.shape) < 0) shapeChoices.push(stone.shape);
      lockedShapes = new Set(shapeChoices.filter(function (x) { return x !== stone.shape; }));
    }
    panel.appendChild(facet('Center stone shape',
      chipGroup(shapeChoices, shape,
        function (v) { if (v) go({ shape: v, seat: null }); }, title, lockedShapes),
      title(shape)));

    // Seats the chosen stone will not physically sit in are disabled for the same
    // reason: this is the control that picks the real Stuller mounting SKU.
    var lockedSeats = null;
    if (stoneSeat) {
      lockedSeats = new Set(seatsFor.filter(function (k) { return !RB.fits(stone, k, style); }));
    }
    /* 🚨 THE CAPTION LIVES INSIDE THE GROUP IT DESCRIBES. It used to be appended
       AFTER this facet with a NEGATIVE top margin, and `.rb-facet` carries a
       `border-bottom` — so the margin pulled the sentence up THROUGH the rule and
       the line ran through the words (owner screenshot, 2026-09-02; measured at
       1440: caption box y 948–970, rule at y 958). A helper line for the size
       picker belongs under the size chips and above the group's rule, which is
       where a product page puts one, and needs no negative margin at all. */
    var seatLbl = function (k) {
      var p2 = RB.parseSeat(k); return p2.l === p2.w ? p2.l + ' mm' : p2.l + '×' + p2.w;
    };
    var sizeBody = chipGroup(seatsFor, seat, function (v) { if (v) go({ seat: v }); },
        seatLbl, lockedSeats);
    if (stoneSeat) {
      sizeBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in' },
        [el('span', { text: 'Cut to hold your ' + stone.l.toFixed(2) + ' × ' +
                             (stone.w || stone.l).toFixed(2) + ' mm ' +
                             title(stone.shape).toLowerCase().replace(/\basscher\b/, 'Asscher') + '. ' }),
         el('a', { href: RB.href(RB.stonesPage(build),
                                 chosen, { stone: null, seat: null }),
                   text: 'Choose a different gemstone' })]));
    }
    panel.appendChild(facet('Center stone size', sizeBody, seat ? seatLbl(seat) : null));

    /* M147: a metal with no accent made at this seat, and an accent not made with the
       pressed metal, are grayed (the size chips' disabled look) with the reason under
       them. Each chip writes only its own value (see `unmade` above). The chip the
       shopper has pressed is never grayed, even where this size is not made in it:
       the line under its group says so instead and asks for one that is. */
    var grayed = function (list, pressed) {
      var out = (list || []).filter(function (x) { return x !== pressed; });
      return out.length ? new Set(out) : null;
    };
    var metalOff = !!combo && combo.offMetals.indexOf(metal) >= 0;
    var metalBody = chipGroup(s.metals, metal, function (v) { if (v) go({ metal: v }); },
      function (m) { return m.replace('14K ', '').replace(' Gold', ''); },
      grayed(combo && combo.offMetals, metal), 'Not made for this center stone size');
    if (combo && combo.offMetals.length) {
      metalBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in', text: metalOff
        ? RB.seatLabel(seat) + ' is not made in ' + metal + '. Choose one of the metals it is made in.'
        : 'Grayed metals are not made for this center stone size.' }));
    }
    // Owner-approved wording (2026-09-25), shown only on a design sold in a two-tone metal.
    if (s.metals.some(function (m) { return TWO_TONE_RE.test(m); })) {
      metalBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in',
        text: 'Two-tone: the first color is the band, the second holds the stone.' }));
    }
    // Owner 2026-10-08: our platinum is 950 (95% pure), said while platinum is the pressed metal, in the words Product
    // Details uses ("950 Platinum").
    if (metal === 'Platinum') {
      metalBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in', text: 'Platinum: 950 platinum, 95% pure.' }));
    }
    panel.appendChild(facet('Metal', metalBody, metal));

    if (s.accents.length > 1) {
      /* COLORED PAVÉ (owner 2026-09-25): a design also sold with lab-grown coloured accents names the choice "Accent
         stones", says which choices are diamonds, and says the coloured ones are lab-grown. Every other design reads
         exactly as before. */
      var colouredAcc = typeof RB.accentCurve === 'function' &&
        s.accents.some(function (a) { return !!RB.accentCurve(a); });
      var accLabel = function (a) {
        return (colouredAcc || accOpts.length) && (a === 'Natural' || a === 'Lab-Grown') ? a + ' Diamond' : a;
      };
      /* A DESIGN WITH AN ACCENT STONE MENU (owner option 1, 2026-11-03) offers its diamond accents here and every
         gemstone through the Accent stones step (the door below): the lab-grown colours sold before the menu are in
         it, so they are not offered twice. A chosen gemstone presses no diamond chip. */
      var accChips = accOpts.length
        ? s.accents.filter(function (a) { return !RB.accentCurve(a); }) : s.accents;
      // while the pressed metal is itself not made here, the accents wait for one that is
      var accentBody = chipGroup(accChips, acc ? null : accent,
        function (v) { if (v) go(accOpts.length ? { accent: v, accentStone: null } : { accent: v }); },
        colouredAcc ? accLabel : null, metalOff ? null : grayed(combo && combo.offAccents, accent),
        'Not made in ' + metal + ' for this center stone size');
      if (acc) {
        accentBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in' }, [
          el('span', { text: RB.accentName(acc) + ', ' + acc.grade + ', ' + acc.stones + ' stones. ' }),
          el('a', { href: RB.href(RB.pages.settings, chosen, { configure: '1', 'for': 'accent' }),
                    text: 'Change' })]));
      } else if (colouredAcc && !accOpts.length) {
        accentBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in',
          text: 'Colored accents are lab-grown.' }));
      }
      if (combo && !metalOff && combo.offAccents.length) {
        accentBody.push(el('p', { class: 'rb-facet__hint rb-facet__hint--in', text: unmade
          ? RB.seatLabel(seat) + ' is not made in ' + metal + ' with ' +
            (accent === 'None' ? 'no' : String(accent).toLowerCase()) +
            ' accents. Choose one of the accents it is made with.'
          : 'Grayed accents are not made in ' + metal + ' for this center stone size.' }));
      }
      panel.appendChild(facet((colouredAcc || accOpts.length) ? 'Accent stones' : 'Accent diamonds', accentBody,
        acc ? RB.accentName(acc) : (colouredAcc || accOpts.length) ? accLabel(accent) : accent));
    }

    /* ── SIDE STONES ARE ANNOUNCED HERE AND CHOSEN AT REVIEW ──────────────────
       Owner question 2026-08-19: "are there supposed to be 4 steps … or should the
       side stone options show in the setting selection screen?" Decision: three
       steps, and the option is announced on the mounting where it is a property of
       the mounting — but it is a NOTE, not a picker.

       🚨 IT CANNOT BE A PICKER ON THE SETTINGS GRID, AND THAT IS A DATA FACT RATHER
       THAN A PREFERENCE. The side spec is keyed by CENTRE SEAT, not by style: this
       one style runs five specs from Oval 4×3 to Oval 8×6 across its own SKUs, a
       4.7x spread in area and a $55–$4,285 spread in price. On the grid no seat is
       chosen, so there is nothing truthful to show. HERE the seat is chosen, so the
       note can state the real size — which is why this is the earliest honest place
       for it, and why it moved here rather than onto the step before.

       ⚠️ IT NAMES THE DEFAULT. "Optional" on its own leaves a shopper wondering what
       they get by ignoring it; the answer is matched diamonds, which is also what
       the render on the next screen draws. */
    var _sides = RB.sideSeat(style, seat);
    if (_sides) {
      panel.appendChild(el('p', { class: 'rb-facet__hint', style: 'margin:1.4rem 0 1.6rem' }, [
        /* 🚨 THIS SENTENCE USED TO SAY "It comes with matched diamonds" AND THAT WAS
           FALSE. Measured 2026-08-20 on 24 ACTIVE variants: Stuller's `SetWith` is
           EMPTY on every one — the mounting arrives with nothing in it. The copy was
           written from the builder's RENDER (which draws diamonds into empty seats,
           by the owner's "nothing renders empty" rule) rather than from the SKU, and
           a render is a picture, not a bill of materials. */
        // ONE stone on a second-stone design reads as one (RB.secondStone; guarded against the engine's previous copy)
        el('span', { text: (RB.secondStone && RB.secondStone(style, _sides))
          ? 'This setting is made with a center stone and a ' + (RB.sideSeatLabel || RB.seatLabel)(_sides.spec, null, style, _sides.set) +
            ' second stone. You choose both — the second stone is its own step, after your center stone.'
          : 'This setting is made with a center stone and ' +
                           (_sides.n || 2) + ' × ' + (RB.sideSeatLabel || RB.seatLabel)(_sides.spec, null, style, _sides.set) +
                           ' side stones. You choose all of them — the side stones ' +
                           'are their own step, after your center stone.' })
        /* ⚠️ DO NOT REACH FOR `piece` HERE. That `var` is declared ~25 lines BELOW,
           so it is hoisted and `undefined` at this point and the sentence renders
           "your undefined" without throwing — the trap the centre-stone curve work
           shipped once already. And this sentence is a concatenation, so a dropped
           fragment renders a grammatical-looking half-sentence: `verify_side_stones`
           EXECUTES it and reads the result rather than grepping for it, which is how
           the last one ("…for colored stones ring.") was caught. */
      ]));
    }

    /* ---- where this button goes depends on whether a stone came with us -------
       Three states, and only the first is the old one:
         no stone           -> step 2, "Choose a gemstone"
         stone that fits    -> STEP 3. Sending these shoppers to step 2 is what
                               made the deep link feel broken: they had already
                               chosen, and the funnel asked again.
         stone that does not fit / did not resolve -> say so, and offer the swap. */
    var piece = RB.KINDS[RB.kind(build)].label;
    var nextPath = RB.stonesPage(build), nextLabel = 'Choose a gemstone →', nextExtra = { configure: null };
    var warn = null;

    if (stoneSeat && _sides) {
      /* 🚨 INTO STEP 3, NOT PAST IT (owner, 2026-08-20). This page is reached with a
         centre stone already in hand, so the next thing owed is the side stones. It
         routed to review for one day — review filled the default silently and the
         shopper met a finished ring having never been shown the step the bar promised
         them. The default still fills; they just get to see it and change it.
         ⚠️ `for` is a MODE and lives outside FIELDS, so it is named explicitly. */
      nextPath = RB.sidePage(chosen);
      nextLabel = (RB.secondStone && RB.secondStone(style, _sides)) ? 'Choose a second stone →' : 'Choose side stones →';
      nextExtra['for'] = 'side';
    } else if (stoneSeat) {
      nextPath = RB.pages.review;
      nextLabel = 'Review your ' + piece + ' →';
    } else if (wantsStone && !stone) {
      // in the URL but not in any shard — a sold serial, or a link from before a
      // recut. Never carry a stone we cannot price into the next step.
      nextExtra.stone = null;
      warn = 'We could not find the gemstone from your link — every serialized stone ' +
             'here is one of one, so it may have just sold. Choose another and the ' +
             'setting you picked stays with you.';
    } else if (stone) {
      nextExtra.stone = null;
      warn = 'This setting cannot be cut for your ' + title(stone.shape).toLowerCase().replace(/\basscher\b/, 'Asscher') +
             ' at ' + stone.l.toFixed(2) + ' × ' + (stone.w || stone.l).toFixed(2) +
             ' mm. Pick another setting, or choose a different gemstone for this one.';
    }
    if (warn) panel.appendChild(el('div', { class: 'rb-note', text: warn }));

    var next = el('a', {
      class: 'btn btn-primary rb-pdp__cta',
      href: RB.href(nextPath, chosen, Object.assign({ shape: shape }, nextExtra)),
      text: nextLabel
    });
    if (unmade) {
      /* M147: the pair the shopper chose is not made at this size, so this button
         goes nowhere until they choose one that is: the gemstone page's refused
         button (ring-builder-stone.js, "Will not fit your setting") -- no address,
         dimmed, the reason as its words (the grayed chips' words). */
      next.removeAttribute('href');
      next.setAttribute('aria-disabled', 'true');
      next.className += ' rb-detail__cta is-disabled';
      next.textContent = 'Not made for this center stone size';
    }
    panel.appendChild(next);

    /* ── THE TWO DOORS, ON THE OTHER ENTRY TO THE SAME DECISION ───────────────
       This is the stone-first path: the shopper already has a centre stone and is
       confirming the mounting, so the next thing owed is exactly what step 2 owes.
       One renderer serves both (`RB.renderSideChoice`) so the two doors cannot come
       to describe one default differently.
       ⚠️ REPLACES the single CTA only once a default resolves — same order and same
       reason as step 2: a build with no colourless diamond for its seat must keep the
       CTA that routes INTO step 3, because there is nothing to proceed with. */
    /* THE ACCENT STONES DOOR (owner 2026-11-03), the side-stone door's markup: the default named, "Proceed" going
       where the CTA goes, and the step to choose them. A build with side stones keeps the side door below. */
    if (accOpts.length && !unmade && !(stoneSeat && _sides)) {
      var _accDoor = el('div', { class: 'rb-sidepick' }, [
        el('p', { class: 'rb-sidepick__k', text: 'Accent stones' }),
        el('p', { class: 'rb-sidepick__t', text: acc ? RB.accentName(acc) + ' accents'
          : ((accent === 'Natural' || accent === 'Lab-Grown') ? accent + ' Diamond' : accent) + ' accents' }),
        el('p', { class: 'rb-sidepick__s', text: acc
          ? [acc.stones + ' stones', acc.grade, '+' + money(acc.charge)].join(' \u00b7 ')
          : 'Included with the setting' }),
        el('a', { class: 'btn btn-primary rb-sidepick__go', href: next.getAttribute('href'),
                  text: 'Proceed with these accent stones \u2192' }),
        el('a', { class: 'rb-sidepick__a',
                  href: RB.href(RB.pages.settings, chosen, { configure: '1', 'for': 'accent' }),
                  text: 'Select accent stones myself' })
      ]);
      next.parentNode.replaceChild(_accDoor, next);
      next = _accDoor;
    }
    if (stoneSeat && _sides && !unmade) {      // M147: no door past a pair that is not made
      RB.sideChoice(chosen, _sides).then(function (choice) {
        if (!choice || !next.parentNode) return;
        next.parentNode.replaceChild(
          RB.renderSideChoice(chosen, choice,
                              Object.assign({ shape: shape }, nextExtra, { 'for': null })),
          next);
      });
    }

    if (warn && stone) {
      panel.appendChild(el('p', { class: 'rb-detail__back', style: 'margin-top:1.2rem' }, [
        el('a', { href: RB.href(RB.pages.settings, build, { style: null, configure: null }),
                  text: '← Back to the settings that fit this stone' })
      ]));
    }
    if (!unmade) panel.appendChild(el('p', {        // M147: it speaks of a price not shown
      class: 'rb-pdp__reassure',
      text: RB.pairQty(build) > 1
        ? ('This price covers both mountings' + (sv && sv[2] ? ' and their matching backs' : '') + '. Your two gemstones are priced separately; the full pair total is shown before checkout.')
        : stoneSeat
        ? 'This price is for the setting alone. Your gemstone is listed separately, ' +
          'and you will see both before you pay.'
        : 'This price is for the setting alone. Your center stone is chosen next and priced separately.'
    }));
    body.appendChild(panel);
  }

  /* -------------------------------------------- grid tile images (M002) ---
     🚨 A 163px PHONE TILE DOWNLOADED THE 765–1,973px ORIGINAL. The settings
     index keeps each photo's bare Shopify URL and the cards used it as `src`: a
     full scroll of the pendant mountings on a phone fetched 228 photos, 11.4 MB
     (site audit 2026-09-16, M002). Each tile now carries what the theme's own
     product card carries: a srcset of the theme's image steps (RB.tileImg) and a
     `sizes` for the browser to choose from. RB.tileFrames' composed renders are
     Stuller's, sized by their rendition, and keep their plain `src`.
     ⚠️ `sizes` IS MEASURED, NOT GUESSED: one column of THIS grid, read off
     `grid-template-columns`, which resolves to pixels once the grid is laid out.
     The grid is 2, 3 or 4 across by breakpoint and stops growing at the page
     width, so any vw rule is soft somewhere (two ~479px tiles at 1023px) or
     wasteful somewhere else. TILE_SIZES is only for a grid that cannot be
     measured, and errs large. ONE ResizeObserver per grid — the element
     outlives every redraw, so it is wired once and reads the newest cards —
     moves `sizes` when the column changes by more than 10% (a rotated phone, a
     resized window).
     ⚠️ BOTH FRAMES GET THE SAME srcset AND sizes, so the hover crossfade (and its
     1.05 zoom) swaps two files of one width, never a sharp one for a soft one.
     ⚠️ `loading` AND `sizes` GO IN BEFORE `srcset` AND `src` (el() sets attributes
     in key order), so nothing is fetched before the browser knows what to fetch.
     ⚠️ RB.tileImg IS NEW WITH THIS CHANGE. For ~20 minutes after a release Shopify
     can pair this file with the previous ring-builder.js; without the helper a
     tile keeps today's bare `src` rather than throwing and drawing no grid. */
  var TILE_SIZES = '(min-width: 1280px) 25vw, (min-width: 1024px) 34vw, 50vw';
  // .rb-style__media img is 92% of an 11rem box from 1024px, of 8.4rem below
  var STRIP_SIZES = '(min-width: 1024px) 96px, 74px';
  function tileCol(grid) {
    var w = 0;
    try {
      String(getComputedStyle(grid).gridTemplateColumns || '').replace(/(\d+(?:\.\d+)?)px/g, function (m, n) {
        w = Math.max(w, +n);
        return m;
      });
    } catch (e) {}
    return w;
  }
  function tileAttrs(url, sizes, attrs, mark) {
    var t = RB.tileImg ? RB.tileImg(url, sizes) : { src: url };
    attrs.sizes = t.sizes;
    attrs.srcset = t.srcset;
    attrs.src = t.src;
    if (mark && t.srcset) attrs['data-rb-tile'] = '';
    return attrs;
  }
  function watchTiles(grid, col) {
    grid.__rbTileCol = col;
    if (grid.__rbTileObs || !RB.tileImg || !window.ResizeObserver) return;
    grid.__rbTileObs = new ResizeObserver(function () {
      var now = tileCol(grid), was = grid.__rbTileCol;
      if (!now || (was && Math.abs(now - was) <= was * 0.1)) return;
      grid.__rbTileCol = now;
      var sz = Math.ceil(now) + 'px';
      Array.prototype.forEach.call(grid.querySelectorAll('img[data-rb-tile]'), function (im) {
        im.setAttribute('sizes', sz);
      });
    });
    grid.__rbTileObs.observe(grid);
  }

  /* =============================================== STEP 1 — settings grid */
  function pageSettings(root, build) {
    var q = new URLSearchParams(location.search);
    // The grid and the detail view share one URL; `configure=1` switches.
    // NOT `view=` — that is a RESERVED Shopify parameter that selects an
    // alternate template (page.rb-settings.detail). It does not exist, so
    // Shopify silently falls back to the default page template and the whole
    // section vanishes. Verified: ?foo=bar renders fine, ?view=detail does not.
    var isDetail = !!(q.get('configure') && q.get('style'));

    /* ---- a stone in the URL is a CONSTRAINT on this step, not a passenger -----
       Arriving from "Set this stone into a ring" showed all 51 ring settings (140
       pendant mountings) when only 14 (19) could hold the stone. Every one of the
       other 37 was a dead end that ended in "that gemstone will not sit in this
       setting size" — or, before the guards added with it, in a cart line the
       bench would have had to reject. Fit is the same test step 2 applies in the
       other direction (RB.fitsStyle: does ANY seat of this style take the stone),
       so neither surface can drift from the other.

       BOTH views wait. The dispatcher re-runs this once the shard is in; drawing
       first would flash 51 settings before cutting to 14, and the detail view
       would announce "we could not find the gemstone" about one that is merely
       still downloading. */
    if (root.__stonePending) {
      var body0 = root.querySelector('[data-rb-body]');
      if (isDetail) {
        if (body0) body0.innerHTML = '<div class="rb-skel" style="grid-column:1/-1;max-width:40rem"></div>';
        return;
      }
      var g0 = root.querySelector('[data-rb-grid]');
      var c0 = root.querySelector('[data-rb-count]');
      if (c0) c0.textContent = 'Finding the settings that fit your gemstone…';
      if (g0) {
        g0.innerHTML = '';
        for (var k0 = 0; k0 < 6; k0++) g0.appendChild(el('div', { class: 'rb-skel' }));
      }
      return;
    }
    if (isDetail) return pageSettingDetail(root, build, q.get('style'));

    var stone = root.__stone || null;
    var showAll = q.get('all') === '1';
    var all = RB.settings();
    var fitting = stone ? all.filter(function (s) { return RB.fitsStyle(s.style, stone); }) : null;
    // `?all=1` is the escape hatch, and it has to exist: a shopper is allowed to
    // decide the setting matters more than the stone they clicked in on, and a
    // grid with no way out of its own filter is a trap.
    // EVERYTHING below reads `pool`, not `all` — the style strip and the shape
    // facet included. A strip still counting all 51 beside a grid of 14 is the
    // same lie in a different font, and its tiles would filter to nothing.
    var pool = (fitting && !showAll) ? fitting : all;
    var fShape = q.get('shape') || build.shape || null;
    var fFamily = q.get('family') || null;
    var fMetal = q.get('metal') || null;
    var sort = q.get('sort') || 'price-asc';

    var rail = root.querySelector('[data-rb-rail]');
    var grid = root.querySelector('[data-rb-grid]');
    var count = root.querySelector('[data-rb-count]');
    var strip = root.querySelector('[data-rb-styles]');
    var sortWrap = root.querySelector('[data-rb-sort]');

    function apply(patch) {
      var n = new URLSearchParams(location.search);
      Object.keys(patch).forEach(function (k) {
        if (patch[k] == null) n.delete(k); else n.set(k, patch[k]);
      });
      // In place once the dispatcher below has handed this page to sr-client-filters.js; a page load otherwise.
      if (root.__srClient && root.__srClient.go('?' + n.toString())) return;
      location.search = n.toString();
    }

    var shapes = {};
    pool.forEach(function (s) { s.shapes.forEach(function (x) { shapes[x] = 1; }); });
    var shapeList = SHAPE_ORDER.filter(function (x) { return shapes[x]; })
      .concat(Object.keys(shapes).filter(function (x) { return SHAPE_ORDER.indexOf(x) < 0; }));
    // The four single metals always; a two-tone only while a design in the pool is sold in it.
    var metals = ['14K Yellow Gold', '14K White Gold', '14K Rose Gold', 'Platinum'].concat(
      TWO_TONE_METALS.filter(function (m) { return pool.some(function (s) { return s.metals.indexOf(m) >= 0; }); }));

    // `family` is a LIST — a design can be both Accented and Solitaire — so
    // membership is "contains", never equality. (It was equality against a value
    // that was always null, which is why the old Style facet matched nothing.)
    // Ring/pendant browse by STONE LAYOUT; earrings browse by CONSTRUCTION —
    // someone after studs is not weighing solitaire against three-stone, they are
    // choosing what hangs off the ear. Both vocabularies live here and a tile is
    // only emitted when it has members (see the FAMILIES.forEach below), so the
    // wrong wave's words simply never appear rather than needing a branch.
    var FAMILIES = [
      { key: 'solitaire', label: 'Solitaire' },
      // PEARL leads for the same reason it leads SHAPE_ORDER: a pearl mounting
      // takes a half-drilled pearl and nothing else, so a pearl shopper should
      // not have to read past four faceted-stone words. 84 of the 140 pendant
      // mountings are pearl and none of them had a family until 2026-08-06 —
      // they were in "All settings" and in no tile.
      { key: 'pearl', label: 'Pearl' },
      { key: 'halo', label: 'Halo' },
      { key: 'three-stone', label: 'Three Stone' },
      { key: 'two-stone', label: 'Two Stone' },
      { key: 'accented', label: 'Accented' },
      { key: 'stud', label: 'Studs' },
      { key: 'hoop', label: 'Hoops' },
      { key: 'drop', label: 'Drops' },
      { key: 'climber', label: 'Climbers' },
      { key: 'jacket', label: 'Jackets' },
      { key: 'bar', label: 'Bar' },
      { key: 'cluster', label: 'Cluster' }
    ];
    var inFamily = function (s, k) { return (s.family || []).indexOf(k) >= 0; };

    /* ---- the style strip: pictures first, the way both benchmarks lead ---- */
    // 🚨 AN EMPTY POOL DRAWS A BLANK WHITE BOX, AND THAT IS WHAT MADE A CORRECT
    // ANSWER LOOK LIKE A BROKEN PAGE (owner, 2026-08-19). With nothing fitting, this
    // strip still rendered its one "All that fit — 0" tile, whose media span has no
    // image to put in it: a 103x103 bordered blank at the top of the page, above the
    // count and above the explanation. The honest sentence — "No setting we stock is
    // cut for this stone", with the commission link — is in the GRID, so every row of
    // dead furniture above it pushes it further down. The owner's window ended one
    // line short of it and the page read as broken rather than as an answer.
    if (strip && !pool.length) strip.innerHTML = '';
    if (strip && pool.length) {
      strip.innerHTML = '';
      var tiles = [{ key: null, label: pool === all ? 'All settings' : 'All that fit',
                     n: pool.length, img: (pool[0] || {}).img }];
      FAMILIES.forEach(function (f) {
        var members = pool.filter(function (s) { return inFamily(s, f.key); });
        if (!members.length) return;
        var withImg = members.filter(function (s) { return s.img; })[0] || members[0];
        tiles.push({ key: f.key, label: f.label, n: members.length, img: withImg.img });
      });
      // …then the marketing cuts off WebCategories (Vintage, Bezel-Set, …). These
      // are what a shopper actually browses by and what the benchmark shows;
      // Stuller's six `family` words alone are far too coarse a strip.
      var cueCounts = {};
      pool.forEach(function (s) {
        (s.cues || []).forEach(function (c) { cueCounts[c] = (cueCounts[c] || 0) + 1; });
      });
      Object.keys(cueCounts).sort(function (a, b) { return cueCounts[b] - cueCounts[a]; })
        .forEach(function (c) {
          var members = pool.filter(function (s) { return (s.cues || []).indexOf(c) >= 0; });
          var withImg = members.filter(function (s) { return s.img; })[0] || members[0];
          tiles.push({ key: 'cue:' + c, label: c.replace(/-/g, ' '),
                       n: members.length, img: withImg && withImg.img });
        });
      var track = el('div', { class: 'rb-styles__track' });
      tiles.forEach(function (tl) {
        track.appendChild(el('button', {
          class: 'rb-style', type: 'button',
          'aria-pressed': String((fFamily || null) === tl.key),
          // No count under the style (owner 2026-09-14: the setting pages never say how
          // many settings exist); the number stays on the tile as data-sr-count.
          'data-sr-count': String(tl.n),
          onclick: function () { apply({ family: tl.key }); }
        }, [
          el('span', { class: 'rb-style__media' }, [
            tl.img ? el('img', tileAttrs(tl.img, STRIP_SIZES, { alt: '', loading: 'lazy' })) : null
          ]),
          el('span', { class: 'rb-style__label', text: tl.label })
        ]));
      });
      strip.appendChild(track);
    }

    // THE FILTER PANEL — the species pages' own rows, tiles and silhouettes.
    // See RB.panelRow / RB.shapeTile in ring-builder.js for why these emit `sb`
    // classes instead of the builder's old `rb-facet` + `rb-chipgrid`.
    // ⚠️ BOTH ROWS ARE `--wide`. They hold tile scrollers, and a scroller in a
    // half-width track shows about four silhouettes before it clips — step 2 marks
    // these automatically from their content (see facet() in ring-builder-stones.js);
    // step 1 has only these two and says so explicitly.
    rail.innerHTML = '';
    // ⚠️ A LABELLED ROW WITH NOTHING IN IT IS NEVER RIGHT. `shapeList` is derived
    // from the pool, so a stone that fits no setting produced "Shape / center stone"
    // over an empty scroller — a control that looks present and offers nothing. Same
    // family as the blank strip tile above, and general rather than scoped to this
    // one state: any future row whose values all disappear now simply does not draw.
    var addRow = function (label, sub, tiles) {
      if (!tiles.length) return;
      rail.appendChild(RB.panelRow(label, sub, [RB.scroller(tiles)], 'sb__row--wide'));
    };
    addRow('Shape', 'center stone', shapeList.map(function (v) {
      return RB.shapeTile({
        shape: v, label: title(v), on: fShape === v,
        onclick: function () { apply({ shape: fShape === v ? null : v }); }
      });
    }));
    addRow('Metal', null, metals.map(function (v) {
      var two = TWO_TONE_RE.test(v);
      var tile = RB.swatchTile({
        sw: metalSwatch(v), label: two ? v.replace('14K ', '').replace(' Gold', '') : v.replace('14K ', ''),
        on: fMetal === v,
        onclick: function () { apply({ metal: fMetal === v ? null : v }); }
      });
      // "Yellow & White" is wider than the tile's one-line label, which would cut it to "Yellow & …"; a two-tone
      // label wraps onto two lines instead.
      if (two) tile.querySelector('.sb-colour__t').style.whiteSpace = 'normal';
      return tile;
    }));

    // `family` carries either a family key or a `cue:Vintage`-style marker; one
    // URL parameter drives the whole strip so a shared link is unambiguous.
    var cueFilter = fFamily && fFamily.indexOf('cue:') === 0 ? fFamily.slice(4) : null;
    var rows = pool.filter(function (s) {
      if (fShape && s.shapes.indexOf(fShape) < 0) return false;
      if (cueFilter) { if ((s.cues || []).indexOf(cueFilter) < 0) return false; }
      else if (fFamily && !inFamily(s, fFamily)) return false;
      if (fMetal && s.metals.indexOf(fMetal) < 0) return false;
      return true;
    });
    rows.sort(function (a, b) {
      return sort === 'price-desc' ? b.min - a.min
           : sort === 'name' ? a.title.localeCompare(b.title) : a.min - b.min;
    });

    count.innerHTML = '';
    var piece1 = RB.KINDS[RB.kind(build)].mount;   // "setting" / "mounting"
    // 🚨 NO NUMBER (owner 2026-09-14): "60 settings" said how many settings exist. What
    // the view is narrowed BY still reads as a sentence; an unnarrowed view says nothing,
    // and an empty grid has its own message below. The number is data-sr-count.
    count.setAttribute('data-sr-count', String(rows.length));
    var narrowedBy = fitting && !showAll ? ' that fit your gemstone'
                   : fShape ? ' that take ' + article(fShape) + ' ' + title(fShape).toLowerCase().replace(/\basscher\b/, 'Asscher') + ' center' : '';
    if (rows.length && narrowedBy) {
      count.appendChild(el('span', { text: piece1.charAt(0).toUpperCase() + piece1.slice(1) + 's' + narrowedBy }));
    }

    // SAY WHAT WAS FILTERED OUT AND OFFER THE WAY BACK. A silently shortened grid
    // is indistinguishable from a small catalogue.
    if (fitting) {
      count.appendChild(el('span', { class: 'rb-count__note' }, showAll
        ? [el('span', { text: 'Showing every ' + piece1 + ', including any that cannot be cut for your gemstone. ' }),
           el('button', { type: 'button', class: 'rb-linkish', text: 'Show only the ' + piece1 + 's that fit',
             onclick: function () { apply({ all: null }); } })]
        : [el('span', { text: stone.title + '. ' }),
           el('button', { type: 'button', class: 'rb-linkish',
             text: 'Show all ' + piece1 + 's instead',
             onclick: function () { apply({ all: '1' }); } })]));
    }

    var SORTS = [
      { value: 'price-asc', label: 'Price: low to high' },
      { value: 'price-desc', label: 'Price: high to low' },
      { value: 'name', label: 'Name' }
    ];
    RB.mountSort(sortWrap, SORTS, sort, function (v) { apply({ sort: v }); });

    // Filters are a drawer at EVERY width here (BE pattern), and Sort already
    // sits beside the button in the same bar — so no duplicate sort control.
    RB.mountFilterDrawer(root, rail, {
      activeCount: [fShape, fMetal].filter(Boolean).length,
      // No "60 Results" line and no number on the button (owner 2026-09-14).
      applyLabel: 'Show ' + piece1 + 's'
    });

    grid.innerHTML = '';
    if (!rows.length) {
      // Distinguish "your filters are too tight" from "nothing we stock is cut for
      // this stone" — they need opposite next moves, and the second one is the
      // bespoke conversation, not a filter to clear.
      grid.appendChild(fitting && !fitting.length
        ? el('div', { class: 'rb-empty' }, [
            el('p', { text: 'No ' + piece1 + ' we stock is cut for ' + stone.title + '.' }),
            el('p', { text: 'A stone this size is usually set by commission. Tell us what ' +
                            'you have in mind and we will quote it.' }),
            // 🚨 BESPOKE, NOT SOURCING. "Bespoke is a piece we MAKE; a sourcing
            // request is a stone we FIND" (CLAUDE.md, 2026-08-21) — and this button
            // says "Commission a Ring" while pointing at the form for requesting a
            // stone the shopper has already chosen. Owner found the identical defect
            // on `stone-set-into.liquid`'s bespoke card 2026-08-24; there were exactly
            // two in the theme and both moved together. Every other sourcing link in
            // the theme is labelled "Request a specific stone" / "Source a X", so the
            // label was always the reliable half — check the label against the href.
            el('a', { class: 'btn btn-primary', style: 'margin-top:1.6rem',
                      href: '/pages/bespoke', text: 'Commission a ' + piece1 })
          ])
        : el('div', { class: 'rb-empty', text: 'No ' + piece1 + 's match those filters. Try clearing one.' }));
      return;
    }
    // THE METAL FILTER RECOLOURS THE GRID; THE SHAPE FILTER HAS TO REDRAW IT.
    // A stored tile is one image per METAL, so a shape click changed nothing —
    // and on ROUND, OVAL and EMERALD it cannot change the row count either
    // (all 51 ring styles take all three), so the entire grid was byte-identical
    // before and after. Owner reported it 2026-08-13: "when a shape is selected
    // the grid does not change… it does so for the metal".
    //
    // `RB.tileFrames` composes the render for the filtered shape at the SAME seat
    // the setting page will open on, so the tile and the hero it clicks into are
    // one ring. Null — no harvested render, i.e. every pendant and earring
    // mounting — keeps the branded photo, sized to this grid's column (M002).
    var tcol = tileCol(grid), tsz = tcol ? Math.ceil(tcol) + 'px' : TILE_SIZES;
    watchTiles(grid, tcol);
    rows.forEach(function (s) {
      // Yellow gold leads when no metal is filtered, matching `s.img` (the
      // featured media) so an unfiltered grid and a shape-filtered one are the
      // same colour. A style without it falls to its first, as the detail page does.
      var m = fMetal ||
        (s.metals.indexOf('14K Yellow Gold') >= 0 ? '14K Yellow Gold' : s.metals[0]);
      // ⚠️ SHAPE, NOT SIZE — and for a stone-first shopper those differ. `fShape`
      // falls back to `build.shape`, so arriving from a stone product page draws
      // the whole grid in that stone's shape, which is the point. But the seat is
      // the shard's ONE representative for the shape, while the detail page will
      // open on RB.bestSeat() — the seat that actually holds THEIR stone. So the
      // millimetres in the tile can differ from the millimetres on the next
      // screen. Deliberate: the alternative is a das per seat on step 1, which is
      // the 160 KB shard this one exists to avoid, and the shape being wrong was
      // the defect — the size being representative never was.
      var tile = fShape ? RB.tileFrames(s.style, fShape, m) : null;
      // A filtered metal with no stored photo of its own (a two-tone metal before its photo run) is DRAWN rather than
      // shown in the featured photo's metal: never one metal's photo under another metal's name.
      if (!tile && fMetal && !(s.imgByMetal || {})[fMetal]) {
        tile = RB.tileFrames(s.style, s.shapes.indexOf('ROUND') >= 0 ? 'ROUND' : s.shapes[0], m);
      }
      // A filtered metal with neither a photograph of its own nor anything to draw has NO picture (the no-image tile,
      // below), never the main photo in another metal (ownPhoto, above). None on 2026-10-05: every offered metal has one.
      var img = tile ? tile.img : (fMetal ? ((s.imgByMetal || {})[fMetal] || null) : s.img);
      // THE HOVER FRAME MUST BE THE SAME METAL AS THE TILE IT COVERS. No fallback to
      // s.imgHover when a metal is filtered: that is yellow gold, so hovering a white
      // gold tile would recolour the ring rather than turn it. Same rule as
      // brand_settings' "never show one metal's photo under another metal's name".
      // Absent -> no element -> the tile simply does not swap, which is right for a
      // design Stuller shot from one angle.
      var hoverSrc = tile ? tile.hover
                          : (fMetal ? (s.imgHoverByMetal || {})[fMetal] : s.imgHover);
      // 🚨 A REAL `src`, EAGERLY — exactly what the theme's own product card does.
      // This was `data-src` promoted on first pointerenter, to save a second image
      // per card. It saved the bytes and broke the interaction: the first hover of
      // any tile had to fetch ~100 KB before it could fade, so the swap lagged, and
      // the SECOND hover of the same tile was instant — which reads as a caching bug
      // rather than a deliberate trade. The theme ships both frames up front
      // (card-product__media-secondary-image) and so does this. `loading="lazy"`
      // still keeps offscreen rows out of the initial load, which is the saving that
      // was actually worth having.
      var hoverImg = (img && hoverSrc) ? el('img', tileAttrs(hoverSrc, tsz, {
        class: 'rb-card__hover' + (tile ? ' rb-card__img--render rb-card__img--' + tile.wave : ''),
        alt: '', 'aria-hidden': 'true', loading: 'lazy'
      }, true)) : null;
      /* 🚨 A COMPOSED TILE IS GENERATED ON DEMAND AND THE GRID FILLS IN SECONDS.
         `tile` is an `RB.tileFrames` render, i.e. a URL Stuller builds when asked:
         measured 2026-08-21 on the live grid with shape=MARQUISE, one viewport of
         nine COLD tiles ran min 1,800ms / median 3,891ms / max 6,514ms, and all 28
         rows of that filter took 20.2s wall. `.rb-card__media` is `--rb-plate`
         (WHITE), so until now a shape or metal click emptied the grid to white
         boxes for that whole time with nothing to say it was working.
         ⚠️ ONLY FOR A COMPOSED RENDER. `s.img` is a stored branded JPEG on
         Shopify's CDN — already fast, usually already cached — and a skeleton
         there would flash on the path that never needed one.
         ⚠️ AND ONLY WHEN IT HAS NOT ALREADY ARRIVED: `loading="lazy"` means a
         card scrolled past may be complete the moment it is built. */
      var firstImg = img ? el('img', tileAttrs(img, tsz, {
        class: 'rb-card__first' + (tile ? ' rb-card__img--render rb-card__img--' + tile.wave : ''),
        alt: s.title, loading: 'lazy'
      }, true)) : null;
      // 🚨 THE SWAP CLASS IS ONLY PRESENT WHEN THERE IS SOMETHING TO SWAP TO, and
      // every hover rule hangs off it. Without this the fade-out on .rb-card__first
      // applied to EVERY card, so a mounting with no second frame — all 140
      // pendants and all 331 earrings, which have never been re-branded — faded its
      // only image to nothing and hovered to a BLANK TILE. The theme guards the
      // same way and for the same reason: `card-product__media-secondary-image` is
      // put on the wrapper only when a second image exists.
      var media = el('span', { class: 'rb-card__media' +
        (hoverImg ? ' rb-card__media--swap' : '') +
        (tile && firstImg ? ' rb-card__media--pending' : '') }, [
          // `--render` insets a LIVE frame to the house margin — see ring-builder.css.
          // Stuller frames its own renders tighter than brand_settings pads ours, so
          // without it the ring grows ~11% the instant a shape is filtered.
          firstImg || el('span', { class: 'rb-noimg', text: 'No image' }),
          hoverImg
        ]);
      if (tile && firstImg) {
        var settled = function () { media.classList.remove('rb-card__media--pending'); };
        // ⚠️ `error` TOO, or a frame that 500s pulses for ever over an empty tile.
        if (firstImg.complete && firstImg.naturalWidth) settled();
        else {
          firstImg.addEventListener('load', settled, { once: true });
          firstImg.addEventListener('error', settled, { once: true });
        }
      }
      var card = el('a', {
        class: 'rb-card',
        href: RB.href(RB.pages.settings, build, { style: s.style, shape: fShape || null, configure: '1' })
      }, [
        media,
        el('span', { class: 'rb-card__body' }, [
          el('span', { class: 'rb-card__title', text: RB.settingName(s.title) }),
          el('span', { class: 'rb-card__price' + (RB.pairQty(build) > 1 ? '' : ' rb-setting-price'), text: 'From ' + money(s.min * RB.pairQty(build)) + (RB.pairQty(build) > 1 ? ' (pair of mountings)' : '') }),
          // 🚨 THE NOTE IS COMPOSED IN PYTHON — setting_card_spec.card_note — and
          // shipped as one string, so the browser formats no numbers and there is
          // no second implementation to drift from the rule. It leads with the
          // design fact (band width, pendant dimensions) because that is the only
          // part of the line that can differ between two cards a shopper is
          // comparing: 89 of 522 settings share a title with another, and the
          // counts alone are byte-identical on 25 of 25 colliding earrings.
          //
          // ⚠️ `note` ABSENT IS AN OLDER SHARD, NOT AN ERROR. Falling back to the
          // exact string this line used to build means a stale asset degrades to
          // the previous card rather than to a blank line — the same rule the
          // `dome` column follows, where `!!undefined` is the old behaviour.
          el('span', { class: 'rb-card__note', text: s.note ||
            (s.shapes.length + ' center shapes · ' + s.metals.length + ' metals') })
        ])
      ]);
      grid.appendChild(card);
    });
  }

  /* ============================================ STEP 2 — gemstone browser */
  // Lives in ring-builder-stones.js — it is the most involved surface in the
  // funnel and follows its own spec (two rails, ordered-scale 4C sliders,
  // preset pills, seat-aware "best match" sort).
  function pageStones(root, build, origin, token) {
    if (RB.mountStones) return RB.mountStones(root, build, origin, token);
    root.querySelector('[data-rb-grid]').innerHTML =
      '<div class="rb-empty">The gemstone browser failed to load. Please refresh.</div>';
  }

  /* ========================================= STEP 2b — one gemstone, in full */
  function pageStoneDetail(root, build, stone) {
    if (RB.mountStoneDetail) return RB.mountStoneDetail(root, build, stone);
    var b = root.querySelector('[data-rb-body]');
    if (b) b.innerHTML = '<div class="rb-empty">This gemstone failed to load. Please refresh.</div>';
  }

  /* "Add to cart — $6,840" (owner 2026-09-17, cart rule 8: builder rings show the total; their parts are itemized just
     above the button). Read off the review summary's own total, so the button can never quote a number the line above it
     does not; plain "Add to cart" while that total is still loading. */
  /* RING SIZING ON THE REVIEW STEP (owner 2026-09-17: the builder charges the ring page's sizing table; the rule is
     RB.sizingFor). The charge for the size chosen, per the whole build -- null for the stocked size, no size yet, or an
     engine older than this file (which has no RB.sizingFor: the menu then shows bare sizes and the Add to cart click
     asks for a refresh instead of adding a ring without its charge). */
  function sizingNow(build) {
    if (!RB.isSized(build) || !build.size || typeof RB.sizingFor !== 'function') return null;
    var z = RB.sizingFor(build, build.size);
    return z.kind === 'charge' ? z : null;
  }
  function sizingTotal(build) {
    if (typeof RB.sizingTotal === 'function') return RB.sizingTotal(build);
    var z = sizingNow(build);  // cached older engine: preserve the reviewed summary fallback
    return z ? z.charge * RB.pairQty(build) : 0;
  }
  // "6 (+$22)" -- the ring page's words (ring-sizing/menu-v2/block.liquid); the stocked size bare.
  function sizeOptionText(build, s) {
    if (typeof RB.sizingFor !== 'function') return RB.sizeLabel(s);
    var z = RB.sizingFor(build, s);
    if (z.kind === 'stock') return RB.sizeLabel(s);
    if (z.kind === 'charge') return RB.sizeLabel(s) + ' (+' + money(z.charge * RB.pairQty(build)) + ')';
    return RB.sizeLabel(s) + ' (contact us)';
  }
  // The "Ring sizing" line above the total: shown only while the chosen size carries a charge.
  function paintSizingLine(root, build) {
    var line = root.querySelector('[data-rb-sizingline]');
    if (!line) return;
    var z = sizingNow(build);
    line.hidden = !z;
    var sub = line.querySelector('.rb-line__sub'), amt = line.querySelector('.rb-line__amt');
    if (sub) sub.textContent = z ? 'Size ' + RB.sizeLabel(build.size) : '';
    if (amt) amt.textContent = z ? money(sizingTotal(build)) : '';
  }
  /* A NEW SIZE, REPAINTED IN PLACE: the line, the total and the button that quotes it. Not `pageReview()` again, for
     the chain's reason: that would rebuild the angle viewer under the shopper. The total is never written over the
     loading placeholder (it is only quoted once the stone has resolved). */
  function repaintSizing(root, build) {
    paintSizingLine(root, build);
    var steps = root.querySelector('[data-rb-steps]');
    if (steps) RB.stepBar(steps, build, 'review');  // size changes also repaint the quote in navigation
    if (typeof root.__partsTotal !== 'number') return;
    root.__baseTotal = root.__partsTotal + sizingTotal(build);
    var totalEl = root.querySelector('[data-rb-total-amt]');
    if (totalEl && /\d/.test(totalEl.textContent || '') && !root.__stonePending) {
      var chain = (root.querySelector('[data-rb-chain] matching-chain') && window.SRChainFit)
        ? window.SRChainFit.chosen() : null;
      totalEl.textContent = money(root.__baseTotal + (chain ? chain.p / 100 : 0));
    }
    var ctaNow = root.querySelector('[data-rb-cta]');
    if (ctaNow && /^Add to cart/.test(ctaNow.textContent || '')) ctaNow.textContent = ctaLabel(root);
  }

  function ctaLabel(root) {
    var t = root && root.querySelector('[data-rb-total-amt]');
    var amt = t ? String(t.textContent || '').trim() : '';
    return /\d/.test(amt) ? 'Add to cart \u2014 ' + amt : 'Add to cart';
  }

  /* ============================================== STEP 3 — review the ring */
  /* ---- ENGRAVING BOX (owner 2026-10-06) ---------------------------------------------------------------------
     The supplier's inside-band engraving, free, on the ring's review step, between the ring size and the final-sale
     note (which stays the last thing before Add to cart). Shown only when the engine has RB.ENGRAVE_V and the chosen
     VARIANT is one the supplier engraves (RB.engraveSpec): bare mountings yes, Semi-Sets, pendants and earrings no.
     Its look is the product page's engraving box (theme_snippets/engraving_property.liquid): the same surface,
     corner, type ramp, heading and wording. Two differences, both because inside-band text is a line of words, not
     an initial: the preview is a wide band under the fields rather than a shape beside them, and the font and color
     fill appear once a message is typed, so a shopper who wants no engraving sees one field, as on that box.
     ⚠️ ONE NODE FOR THE PAGE'S LIFE. pageReview empties and redraws the summary on every pass (a stone resolving
     redraws it), so the box is built once per variant and MOVED into each new summary: a shopper typing while the
     stone loads keeps their focus and their words. The words also live in sessionStorage, so going back to change
     the stone or the setting keeps them, and the cart's "Change" link puts a cart build's engraving back there
     (rb-cart-pair.js engravingCarry; Codex review-muwn6qol-q5s3ih, and for a new tab review-mv9c1jvh-nfj7ij); a
     successful add clears them. Never in the URL
     (shared links, analytics). A setting the supplier does not engrave shows no box, and says the kept words will
     not be added rather than dropping them silently. */
  var ENGRAVE_KEY = 'sr-rb-engrave';
  // The preview's metal, as the product-page box tints its shape: [light, dark].
  var ENGRAVE_GRAD = { y: ['#f0d78f', '#b8912f'], w: ['#eceef1', '#b7bcc4'], r: ['#eec3ac', '#c98a6d'],
                       p: ['#eef0f2', '#c2c6cc'] };
  // The fill colors as the preview and the swatches draw them (the enamel's own shades vary; these are named).
  var ENGRAVE_INK = { Black: '#1d1d1f', Blue: '#1f4e9c', Brown: '#6b4226', Green: '#1f7a3a', Pink: '#e48aae',
                      Red: '#b3202a' };
  function engraveStore(v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(ENGRAVE_KEY) || 'null');
      if (v === null) sessionStorage.removeItem(ENGRAVE_KEY);
      else sessionStorage.setItem(ENGRAVE_KEY, JSON.stringify(v));
    } catch (e) {}
    return null;
  }
  // Every draft/edit has its own opaque flow. A fresh builder entry does not inherit another build's words.
  // The href wrapper also preserves that identity beside a cached older engine (which lacks the FIELDS entry).
  var engraveHref = RB.href;
  RB.href = function (path, build, extra) {
    var flow = build && (build.engrave_flow || new URLSearchParams(location.search).get('engrave_flow'));
    if (flow && RB.kind(build) === 'ring' && (!extra || extra.engrave_flow !== null)) {
      extra = Object.assign({}, extra || {}, { engrave_flow: flow });
    }
    return engraveHref(path, build, extra);
  };
  function engraveFlow(build) {
    if (!build.engrave_flow) {
      var given = new URLSearchParams(location.search).get('engrave_flow');
      build.engrave_flow = given || 'e-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      var url = new URL(location.href);
      url.searchParams.set('engrave_flow', build.engrave_flow);
      try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) {}
      /* LINKS DRAWN BEFORE THE ID EXISTED LEAD AWAY AND BACK WITH ANOTHER ONE (Codex review-mv9cr510-3i3fbb, medium): when
         the setting's variant data lands after the stone, the step bar was drawn first, its Change links carried no id,
         and coming back made a new one, so the words saved under this one were ignored and the box came up empty with
         Add enabled. pageReview now creates the id before it draws anything (the edit below), and an id made late draws
         the bar again so no link is left without it. An id taken from the address needs no redraw. */
      var bar = !given && RB.kind(build) === 'ring' && document.querySelector('[data-rb-steps]');
      if (bar && typeof RB.stepBar === 'function') RB.stepBar(bar, build, 'review');
    }
    return build.engrave_flow;
  }
  /* A cart Change link also leaves the words in localStorage under its flow id (rb-cart-pair.js engravingKeep), so a link
     opened in a new tab, which never ran its click handler, still finds them (Codex review-mv9c1jvh-nfj7ij, medium).
     KEEP THE KEY AND THE LIFETIME EQUAL TO THAT FILE'S. */
  var ENGRAVE_FLOW_KEY = 'sr-rb-engrave-flow:', ENGRAVE_FLOW_LIFE = 6 * 60 * 60 * 1000;
  function engraveCarried(flow) {
    if (!/^c-/.test(flow)) return null;
    try {
      var rec = JSON.parse(localStorage.getItem(ENGRAVE_FLOW_KEY + flow) || 'null');
      if (!rec || rec.flow !== flow || !(Date.now() - rec.at < ENGRAVE_FLOW_LIFE) || !String(rec.text || '').trim()) return null;
      return { text: rec.text, label: rec.label, color: rec.color || RB.ENGRAVE_NONE, flow: flow };
    } catch (e) { return null; }
  }
  function engraveForget(flow) {
    try { localStorage.removeItem(ENGRAVE_FLOW_KEY + flow); } catch (e) {}
  }
  function engraveSaved(build) {
    var flow = engraveFlow(build), saved = engraveStore();
    if (saved && saved.flow === flow) return saved;
    var carried = engraveCarried(flow);
    if (carried) { engraveStore(carried); return carried; }
    return null;
  }
  // A cart build that HAD engraving (flow `c-`) whose words cannot be found: never treated as an unengraved build.
  function engraveUnresolved(build) {
    return RB.kind(build) === 'ring' && /^c-/.test(engraveFlow(build)) && !engraveSaved(build);
  }
  function engraveBlocked(root, build) {
    if (RB.kind(build) !== 'ring') return false;
    if (engraveUnresolved(build)) return true;
    var raw = engraveStore(), saved = engraveSaved(build);
    // A legacy/unbound handoff is refused, never treated as this build's engraving or silently dropped.
    if (raw && raw.text && !raw.flow) return true;
    return !!(saved && String(saved.text || '').trim() &&
      (!RB.ENGRAVE_V || typeof RB.engraveSpec !== 'function' || !window.RB_ENGRAVE));
  }
  /* `failed` is true only once the options really did not load (the request failed, or came back empty), or when
     nothing can load them. While the request is in flight (root.__engraveWait) the shopper reads a neutral line, not
     the failure wording and a reload button: that flashed on every normal load with saved words (Claude review of
     codex/integrate-consumers-1009, finding 3). The CTA stays disabled either way. */
  function engraveUnavailable(root, build, summary, failed) {
    if (!engraveBlocked(root, build)) return;
    var raw = engraveStore(), saved = engraveSaved(build);
    var legacy = !!(raw && !raw.flow) || engraveUnresolved(build);
    var loading = !failed && !legacy && !!root.__engraveWait;
    var words = legacy
      ? 'We could not match the saved engraving to this build. Return to the cart and choose Change again.'
      : loading ? 'Loading your engraving options…'
      : 'We could not load the options for your engraving “' + saved.text + '”. Refresh this page to keep it. Your words are saved.';
    var note = summary.querySelector('[data-rb-engrave-load]');
    if (!note) {
      note = el('div', { class: 'rb-note rb-note--engrave', 'data-rb-engrave-load': '' }, [
        el('strong', { text: 'Engraving. ' }),
        el('span', { 'data-rb-engrave-words': '', text: words })
      ]);
      summary.appendChild(note);
    } else {
      var span = note.querySelector('[data-rb-engrave-words]');
      if (span) span.textContent = words;
    }
    var retry = note.querySelector('button');
    if (loading || legacy) {                       // nothing a reload would fix yet / ever: no button
      if (retry && retry.parentNode) retry.parentNode.removeChild(retry);
    } else if (!retry) {
      retry = el('button', { type: 'button', class: 'rb-linkish', text: 'Refresh engraving options' });
      retry.addEventListener('click', function () { location.reload(); });
      note.appendChild(retry);
    }
    var cta = root.querySelector('[data-rb-cta]');
    if (cta) cta.disabled = true;
  }
  function engraveMetal(metal) {
    var m = String(metal || '');
    return /Yellow/.test(m) && !/White/.test(m) ? 'y' : /Rose/.test(m) ? 'r' : /Platinum/.test(m) ? 'p' : 'w';
  }
  // The shopper's engraving for RB.addToCart, or null (no box, or no words).
  function engraveChoice(root) {
    var st = root.__engrave;
    if (!st || !st.node || !st.node.isConnected) return null;
    var text = RB.engraveClean(st.text).trim();
    return text ? { text: text, font: st.font, color: st.color } : null;
  }
  function engraveFit(n) { return n <= 8 ? 28 : (n <= 11 ? 24 : 21); }
  function engravePaint(root) {
    var st = root.__engrave, n = st && st.node;
    if (!n) return;
    var text = RB.engraveClean(st.text).trim();
    var font = (st.spec.fonts || []).filter(function (f) { return String(f.id) === String(st.font); })[0];
    n.querySelector('.rb-engrave__count').textContent = RB.engraveClean(st.text).length + '/' + st.max;
    n.querySelector('.rb-engrave__more').hidden = !text;
    var g = ENGRAVE_GRAD[engraveMetal(st.metal)];
    n.querySelector('[data-stop="0"]').setAttribute('stop-color', g[1]);
    n.querySelector('[data-stop="1"]').setAttribute('stop-color', g[0]);
    n.querySelector('[data-stop="2"]').setAttribute('stop-color', g[1]);
    var ink = st.color !== RB.ENGRAVE_NONE && ENGRAVE_INK[st.color];
    [n.querySelector('.rb-engrave__glyph'), n.querySelector('.rb-engrave__glyph-hi')].forEach(function (t, i) {
      t.textContent = text;
      t.setAttribute('font-size', engraveFit(text.length));
      if (i === 0) t.setAttribute('fill', ink || '#00000059');
    });
    n.querySelector('.rb-engrave__pv-text').textContent = text || '—';
    n.querySelector('.rb-engrave__pv-style').textContent = (font ? font.label : '') +
      (ink ? ' · ' + st.color.toLowerCase() + ' fill' : '');
    Array.prototype.forEach.call(n.querySelectorAll('.rb-engrave__radio'), function (r) {
      r.checked = r.name === 'rb-engrave-font' ? String(r.value) === String(st.font) : r.value === st.color;
      r.parentNode.classList.toggle('is-on', r.checked);
    });
  }
  function engraveSave(root) {
    var st = root.__engrave;
    var font = (st.spec.fonts || []).filter(function (f) { return String(f.id) === String(st.font); })[0];
    // a cart-edit flow keeps an explicit "no words" record: clearing the box is an answer, not a missing handoff
    engraveStore(RB.engraveClean(st.text) ? { text: st.text, font: st.font, label: font ? font.label : '',
                                               color: st.color, flow: st.flow }
                 : (/^c-/.test(st.flow) ? { text: '', flow: st.flow } : null));
  }
  function engraveBuild(root, build, spec, vid) {
    var max = spec.max || 13;
    var saved = engraveSaved(build);
    var fonts = spec.fonts || [];
    var def = fonts.filter(function (f) { return f.def; })[0] || fonts[0] || {};
    var st = root.__engrave = { vid: vid, flow: engraveFlow(build), spec: spec, max: max, metal: build.metal, node: null,
                                text: '', font: def.id, color: RB.ENGRAVE_NONE };
    if (saved && saved.text) {
      // checked against THIS setting's offer: a font or fill it does not have falls back to the default, in view
      st.text = RB.engraveClean(saved.text).slice(0, max);
      var keep = fonts.filter(function (f) { return String(f.id) === String(saved.font); })[0] ||
                 fonts.filter(function (f) { return saved.label && f.label === saved.label; })[0];
      if (keep) st.font = keep.id;
      if (saved.color === RB.ENGRAVE_NONE || (spec.colors || []).indexOf(saved.color) >= 0) st.color = saved.color;
    }
    var input = el('input', { id: 'rb-engrave-text', class: 'rb-engrave__input', type: 'text', maxlength: String(max),
                              autocomplete: 'off', spellcheck: 'false',
                              placeholder: 'Forever yours', 'aria-describedby': 'rb-engrave-count rb-engrave-hint' });
    input.value = st.text;
    var hint = el('p', { class: 'rb-engrave__hint', id: 'rb-engrave-hint', hidden: 'hidden',
                         text: 'Letters, numbers, spaces and simple punctuation only.' });
    input.addEventListener('input', function () {
      var raw = input.value, clean = RB.engraveClean(raw).slice(0, max);
      hint.hidden = clean === raw.replace(/\s+/g, ' ').replace(/^ /, '').slice(0, max);
      if (clean !== raw) {
        var at = input.selectionStart - (raw.length - clean.length);
        input.value = clean;
        try { input.setSelectionRange(Math.max(0, at), Math.max(0, at)); } catch (e) {}
      }
      st.text = clean;
      engravePaint(root);
      engraveSave(root);
    });
    var fontTiles = fonts.map(function (f) {
      return el('label', { class: 'rb-engrave__font' }, [
        el('input', { type: 'radio', class: 'rb-engrave__radio', name: 'rb-engrave-font', value: String(f.id) }),
        el('img', { src: f.img, alt: f.label, width: String(f.w), height: String(f.h), draggable: 'false' })
      ]);
    });
    var colorPills = [RB.ENGRAVE_NONE].concat(spec.colors || []).map(function (c) {
      return el('label', { class: 'rb-engrave__color' }, [
        el('input', { type: 'radio', class: 'rb-engrave__radio', name: 'rb-engrave-color', value: c }),
        el('span', { class: 'rb-engrave__dot' + (c === RB.ENGRAVE_NONE ? ' rb-engrave__dot--none' : ''),
                     style: c === RB.ENGRAVE_NONE ? null : 'background:' + (ENGRAVE_INK[c] || '#888'),
                     'aria-hidden': 'true' }),
        el('span', { text: c })
      ]);
    });
    var pv = el('div', { class: 'rb-engrave__pv' });
    pv.innerHTML =
      '<svg viewBox="0 0 320 72" width="100%" aria-hidden="true" focusable="false" class="rb-engrave__band">' +
      '<defs><linearGradient id="rbEngraveGrad" x1="0" y1="0" x2="0" y2="1">' +
      '<stop data-stop="0" offset="0"/><stop data-stop="1" offset=".48"/><stop data-stop="2" offset="1"/>' +
      '</linearGradient></defs>' +
      '<rect x="4" y="8" width="312" height="56" rx="28" fill="url(#rbEngraveGrad)" stroke="#00000022"/>' +
      '<rect x="4" y="9.2" width="312" height="56" rx="28" fill="none" stroke="#ffffff55" stroke-width="1"/>' +
      '<text class="rb-engrave__glyph-hi" x="160" y="37.2" text-anchor="middle" dominant-baseline="central" ' +
      'font-family="Georgia,\'Times New Roman\',serif" font-style="italic" fill="#ffffff80"></text>' +
      '<text class="rb-engrave__glyph" x="160" y="36" text-anchor="middle" dominant-baseline="central" ' +
      'font-family="Georgia,\'Times New Roman\',serif" font-style="italic"></text></svg>';
    pv.appendChild(el('div', { class: 'rb-engrave__pv-cap' }, [
      el('div', {}, [el('span', { text: 'Inside: ' }), el('strong', { class: 'rb-engrave__pv-text' })]),
      el('div', { class: 'rb-engrave__pv-style' }),
      el('div', { class: 'rb-engrave__pv-note', text: 'Live preview. The engraving is cut in the font you choose.' })
    ]));
    var node = el('div', { class: 'rb-engrave', 'data-rb-engrave': '' }, [
      el('div', { class: 'rb-engrave__head', text: 'Make it yours — complimentary engraving' }),
      el('p', { class: 'rb-engrave__sub', text: 'Add a laser-engraved message inside the band, up to ' + max +
                ' characters. Optional; leave blank for none.' }),
      el('label', { class: 'rb-engrave__lbl', for: 'rb-engrave-text', text: 'Message' }),
      el('div', { class: 'rb-engrave__field' }, [
        input, el('span', { class: 'rb-engrave__count', id: 'rb-engrave-count' })
      ]),
      hint,
      el('div', { class: 'rb-engrave__more', hidden: 'hidden' }, [
        el('fieldset', { class: 'rb-engrave__set' }, [
          el('legend', { class: 'rb-engrave__lbl', text: 'Font' }),
          el('div', { class: 'rb-engrave__fonts' }, fontTiles)
        ]),
        el('fieldset', { class: 'rb-engrave__set' }, [
          el('legend', { class: 'rb-engrave__lbl', text: 'Color fill' }),
          el('div', { class: 'rb-engrave__colors' }, colorPills)
        ]),
        pv
      ]),
      el('p', { class: 'rb-engrave__fine', text: 'Laser-engraved to order.' })
    ]);
    node.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || !r.classList || !r.classList.contains('rb-engrave__radio')) return;
      if (r.name === 'rb-engrave-font') st.font = r.value; else st.color = r.value;
      engravePaint(root);
      engraveSave(root);
    });
    st.node = node;
    engravePaint(root);
    return node;
  }
  /* Put the box in this pass's summary: after the ring size, before the notes. Builds it when the data is in, the
     engine is this release's and the variant is engravable; otherwise removes any earlier box (a changed variant)
     and, the first time, fetches the data and places it when it lands. */
  function engravePlace(root, build, summary) {
    if (RB.kind(build) !== 'ring') return;
    engraveFlow(build);
    if (typeof RB.engraveSpec !== 'function' || !RB.ENGRAVE_V) {
      engraveUnavailable(root, build, summary);
      return;
    }
    if (!window.RB_ENGRAVE) {
      var start = !root.__engraveWait && !!RB.loadAsset;
      if (start) root.__engraveWait = true;
      // failed = nothing is loading and nothing can: no loader at all (an engine this page cannot load from)
      engraveUnavailable(root, build, summary, !root.__engraveWait);
      if (!start) return;
      // Saved words block the CTA while the data is out: a full repaint then recomputes its stone/side gates too.
      // With no saved words nothing was blocked, so the box is placed in the existing summary without redrawing the
      // image viewer and the size select (the sizing code deliberately avoids that).
      var wasBlocked = engraveBlocked(root, build);
      var here = function () { return root.querySelector('[data-rb-summary]') || summary; };
      RB.loadAsset('rb-ring-engrave.js', 'RB_ENGRAVE').then(function () {
        root.__engraveWait = false;
        if (!window.RB_ENGRAVE) engraveUnavailable(root, build, here(), true);
        else if (wasBlocked) pageReview(root, build);
        else engravePlace(root, build, here());
      }).catch(function () {
        root.__engraveWait = false;
        engraveUnavailable(root, build, here(), true);
      });
      return;
    }
    if (engraveBlocked(root, build)) {
      engraveUnavailable(root, build, summary);
      return;
    }
    var spec = RB.engraveSpec(build);
    var sv = RB.settingVariant(build);
    var vid = sv ? String(sv[0]) : '';
    var st = root.__engrave;
    var node;
    if (!spec) {
      if (st && st.node && st.node.parentNode) st.node.parentNode.removeChild(st.node);
      root.__engrave = null;
      /* KEPT WORDS ON A SETTING THE SUPPLIER DOES NOT ENGRAVE ARE NAMED, NOT DROPPED (Codex review-muwn6qol-q5s3ih):
         words typed on another setting, or handed back by the cart's Change link. The add sends no engraving. */
      var saved = engraveSaved(build);
      var text = saved && RB.engraveClean(saved.text).trim();
      if (!text) return;
      node = el('div', { class: 'rb-note rb-note--engrave', 'data-rb-engrave-none': '' }, [
        el('strong', { text: 'Engraving. ' }),
        el('span', { text: 'This setting cannot be engraved, so your engraving “' + text + '” will not be ' +
                           'added. Choose an engravable setting to keep it.' })
      ]);
    } else {
      node = (st && st.vid === vid && st.flow === build.engrave_flow && st.node) ? st.node : engraveBuild(root, build, spec, vid);
    }
    var size = summary.querySelector('.rb-size');
    var note = summary.querySelector('.rb-note');
    if (size) size.parentNode.insertBefore(node, size.nextSibling);
    else if (note) summary.insertBefore(node, note);
    else summary.appendChild(node);
  }

  function pageReview(root, build) {
    var setting = RB.setting(build.style);
    var stage = root.querySelector('[data-rb-stage]');
    var angleBar = root.querySelector('[data-rb-angles]');
    var summary = root.querySelector('[data-rb-summary]');
    var cta = root.querySelector('[data-rb-cta]');
    if (!setting || !build.seat) {
      root.querySelector('[data-rb-body]').innerHTML =
        // "setting" on a ring, "mounting" on a pendant — the builder's own noun
        '<div class="rb-empty">Start by choosing a ' + RB.KINDS[RB.kind(build)].mount + '.</div>';
      return;
    }
    // the engraving flow id first: every link this page draws, from the first pass on, carries it
    // (Codex review-mv9cr510-3i3fbb: variant data arriving after the stone drew the step bar without it)
    if (RB.kind(build) === 'ring') engraveFlow(build);
    /* THE VARIANTS MAY STILL BE ON THEIR WAY (2026-09-21). This page used to get the
       whole 2 MB table from a script tag ahead of the builder's own scripts, which
       held the page for 8-20 s on a cold CDN. Where that tag is gone the chosen
       style's shard is fetched here instead. Until it lands `RB.settingVariant`
       answers null for "not loaded", which the refusal below would read as "not
       made" — so wait, touch nothing but the button, and draw when it is in.
       `settingVariantsReady` turns true even when every fetch failed, so this
       cannot loop. Feature-tested: beside a cached previous ring-builder.js the
       page behaves exactly as before. */
    if (RB.settingVariantsReady && !RB.settingVariantsReady(build.style)) {
      if (cta) cta.disabled = true;
      // The dispatcher repaints this page as each stone resolves; one wait serves
      // them all. `build` is the dispatcher's own object, updated in place.
      if (root.__variantsWait) return;
      root.__variantsWait = true;
      RB.loadSettingVariants(build.style).then(function () {
        root.__variantsWait = false;
        var bar = root.querySelector('[data-rb-steps]');
        if (bar) RB.stepBar(bar, build, 'review');
        try { pageReview(root, build); } catch (e) {}
      });
      return;
    }
    /* ACCENT STONES (colored pavé, owner option 1, 2026-11-03): a ring design with accents waits for its accent menu
       the way it waits for its variants above, so accent stones are never priced or carted before their charge is
       known (RB.accentFor). It resolves when nothing loads, and a design with no menu then reads as before. */
    if (RB.kind(build) === 'ring' && typeof RB.loadAccentMenu === 'function' && !root.__accentTried &&
        setting.accents && setting.accents.length > 1) {
      if (cta) cta.disabled = true;
      if (root.__accentWait) return;
      root.__accentWait = true;
      RB.loadAccentMenu(build.style).then(function () {
        root.__accentWait = false;
        root.__accentTried = true;
        try { pageReview(root, build); } catch (e) {}
      });
      return;
    }
    /* An already-shared link carries the stale value straight here, so the detail
       page's correction never runs. Normalise against the chosen style FIRST and only
       then decide whether the combination really is unavailable — otherwise the
       shopper is told to "choose the setting options again" for a ring we can in fact
       make. ⚠️ `build` itself is updated, not just the lookup: the price, the cart
       payload and the summary all read it, and a build that renders as one thing and
       carts as another is worse than the refusal. */
    var _sty = RB.setting(build.style);
    var _ours = { metal: false, accent: false };      // M147: the values WE filled in
    if (_sty) {
      var _fixed = RB.normalizeToStyle(build, _sty);
      if (_fixed.metal !== build.metal || _fixed.accent !== build.accent) {
        _ours = { metal: _fixed.metal !== build.metal, accent: _fixed.accent !== build.accent };
        build.metal = _fixed.metal;
        build.accent = _fixed.accent;
      }
    }
    /* ...AND AGAINST THIS SEAT (M147, 2026-09-25). A default we filled in must be a
       pair this center size is made in, so it is replaced by one that is, silently,
       the same as normalizeToStyle above. A metal or accent the SHOPPER chose is never
       swapped here: the refusal below names it and offers the made pair as a link. */
    var _combo = (_sty && typeof RB.validCombo === 'function')
      ? RB.validCombo(build.style, build.seat, build.metal, build.accent) : null;
    if (_combo && _combo.changed &&
        (_combo.metal === build.metal || _ours.metal) &&
        (_combo.accent === build.accent || _ours.accent)) {
      build.metal = _combo.metal;
      build.accent = _combo.accent;
      var _bar = root.querySelector('[data-rb-steps]');
      if (_bar) RB.stepBar(_bar, build, 'review');
    }
    var sv = RB.settingVariant(build);
    /* ACCENT STONES THIS SEAT AND METAL DO NOT OFFER are said plainly and never priced: the setting would be the empty
       mounting with no charge for what fills it. Offer the same ring with its diamond accents, or the step again. */
    var acc = (build.accentStone && typeof RB.accentFor === 'function') ? RB.accentFor(build) : null;
    if (build.accentStone && !acc) {
      var _boxA = root.querySelector('[data-rb-body]');
      _boxA.innerHTML = '';
      _boxA.appendChild(el('div', { class: 'rb-empty' }, [
        el('span', { text: 'Those accent stones are not offered in ' + build.metal + ' for the ' +
                           RB.seatLabel(build.seat) + ' center stone. ' }),
        el('a', { href: RB.href(RB.pages.review, build, { accentStone: null }),
                  text: 'Review it with diamond accents' }),
        el('span', { text: ', or ' }),
        el('a', { href: RB.href(RB.pages.settings, build, { configure: 1, 'for': 'accent' }),
                  text: 'choose accent stones again' }),
        el('span', { text: '.' })
      ]));
      if (cta) { cta.disabled = true; cta.hidden = true; }
      return;
    }
    // NO VARIANT FOR THIS COMBINATION. `settingPrice` below falls back to 0, so
    // the page used to show the setting at $0, a total that silently omitted it,
    // and a live "Add to cart" that then rejected with 'setting variant not
    // found'. Reachable from any shared or hand-edited URL — e.g. an accent the
    // style does not offer — and the whole builder is built on shareable URLs.
    // Say so and stop, rather than quoting a price we cannot sell.
    if (!sv && _combo && _combo.changed) {
      /* M147: the shopper's own pair, not made for this center size. Say which, and
         offer the pair that IS made (never repriced without their click). */
      var _pair = function (m, a) {
        return m + (a && a !== 'None' ? ' with ' + String(a).toLowerCase() + ' accents' : '');
      };
      var _box = root.querySelector('[data-rb-body]');
      _box.innerHTML = '';
      _box.appendChild(el('div', { class: 'rb-empty' }, [
        el('span', { text: 'That combination is not available: ' + _pair(build.metal, build.accent) +
                           ' is not made for the ' + RB.seatLabel(build.seat) + ' center stone. ' }),
        el('a', { href: RB.href(RB.pages.review, build, { metal: _combo.metal, accent: _combo.accent }),
                  text: 'Review it in ' + _pair(_combo.metal, _combo.accent) }),
        el('span', { text: ', or ' }),
        el('a', { href: RB.href(RB.pages.settings, build, { configure: 1 }),
                  text: 'choose the setting options again' }),
        el('span', { text: '.' })
      ]));
      if (cta) { cta.disabled = true; cta.hidden = true; }
      return;
    } else if (!sv) {
      root.querySelector('[data-rb-body]').innerHTML =
        '<div class="rb-empty">That combination is not available. ' +
        'Please <a href="' + RB.href(RB.pages.settings, build, { configure: 1 }) +
        '">choose the setting options again</a>.</div>';
      if (cta) { cta.disabled = true; cta.hidden = true; }
      return;
    }

    /* 🚨 A STONE IN THE URL THAT WE COULD NOT RESOLVE IS NOT "NO STONE CHOSEN".
       It rendered as exactly that: the summary said "No center stone chosen", the
       total quoted the setting alone — $515 against a build carrying a $3,065
       diamond — and Add to cart stayed LIVE, because addToCart reads
       `build.stone` (present) while the fit guard reads `root.__stone` (null) and
       therefore never runs. So the one build that reached the cart unchecked was
       the one we understood least. Reachable from any shared link, and it was the
       ordinary case for anything arriving from a stone product page.
       `__stonePending` is the still-loading state and must NOT trip this. */
    if (build.stone && !root.__stone && root.__stoneResolved) {
      root.querySelector('[data-rb-body]').innerHTML =
        '<div class="rb-empty"><p>We could not find the gemstone from this link.</p>' +
        '<p>Every serialized stone here is one of one, so it may have just sold. ' +
        'Your ' + RB.KINDS[RB.kind(build)].label + ' setting is safe — ' +
        '<a href="' + RB.href(RB.stonesPage(build),
                              build, { stone: null }) +
        '">choose another gemstone</a> and it will be waiting.</p></div>';
      if (cta) { cta.disabled = true; cta.hidden = true; }
      return;
    }
    // 🚨 DECLARED HERE, NOT AT THE PRICE BLOCK BELOW, AND THAT IS THE WHOLE
    // POINT. This used to be `var stone = root.__stone || null` further down,
    // next to `stonePrice` — so passing `stone` to anglesFor read the HOISTED
    // binding, which is `undefined` until that later line executes. The ring
    // rendered as a white diamond, on a page where the stone was resolved, the
    // title was right and the price was right. Nothing threw: `undefined` is a
    // perfectly good "no stone" argument. Keep this above its first use.
    var stone = root.__stone || null;
    // The stone goes in so the ring is drawn with the centre the shopper chose,
    // not with a white diamond. It is already resolved by this point — it is what
    // the fit guard above just checked — so this costs nothing and cannot lag.
    /* 🚨 A DOMED STONE IS NOT DRAWN WITH A CURVE — IT IS DRAWN WITH ITS PHOTOGRAPH
       (owner, 2026-08-17: *"cabochon stones appear faceted in the rendering, which is
       not just a color inaccuracy"*).

       Stuller ships NO non-faceted stone material. Seventeen candidate object names
       were probed against a control seat — `stones/cabochon/g_Center`, `/cabs/`,
       `/smooth/`, `/opaque/`, `/dome/`, `/opal/`, `/pearl/` and the rest — and every
       one came back byte-identical to the no-centre-object baseline, i.e. the name
       does nothing. Only `stones/faceted` and `stones/diamonds` exist. So a domed
       centre has exactly two renderable outcomes and both are wrong: coloured WITH
       FACETS (101 of ours) or a white faceted diamond (77, the opal refusal). The
       geometry is not a bug to fix, it is a capability Stuller does not have.

       Passing `null` here keeps the MOUNTING render honest — the ring is still shown,
       with the same white centre it would have had before any of the curve work — and
       the stone's own photograph is added below, which is the only accurate picture of
       a cabochon we possess. Owner's choice of the three options, 2026-08-17.
       ⚠️ `stone.domed` comes off the shard's `dome` column and is `false` on a shard
       built before today, so a stale shard degrades to exactly the old behaviour. */
    var domed = !!(stone && stone.domed);
    // The side stone goes in too, so the stage draws the ring the shopper
    // configured rather than one with diamond sides it will not ship with.
    var angles = RB.anglesFor(build.style, build.seat, build.metal,
                              domed ? null : stone, root.__sideStone || null, build.accentStone || build.accent);

    // Five discrete angles, dragged through — still not a continuous spin, and
    // still not interpolated between: Stuller ships no frame sequence for
    // mountings (see the note on RB.mountAngleViewer for what was re-measured
    // to confirm that, including the second row of `FullySetImages`, which is
    // the same five cameras with a wedding band and not five more). What
    // changed 2026-08-13 is that the frames are now ordered physically, scale-
    // normalised so the ring stops growing and shrinking as it turns, and
    // zoomable into the 1500px asset that was already being downloaded.
    stage.innerHTML = '';
    /* THE PHOTOGRAPH, for a stone the renderer cannot draw. Inserted BEFORE the
       viewer is built so it sits directly under the stage and above the angle bar —
       the same slot the hand view uses. Only for a domed centre: on every other stone
       the render already shows the real cut in its real colour, and a second picture
       there would be noise. `stone.img` is the branded, normalised, face-up master and
       is present on 100% of coloured stones (2,094 of 2,094 distinct photographs). */
    /* 🚨 AN EARRING MOUNTING IS A PHOTOGRAPH, NOT A RENDER — SO IT CANNOT SHOW THE
       SHOPPER'S STONE EITHER, AND SINCE 2026-08-21 IT SHOWS A WHITE DIAMOND.
       The earring wave falls through to the `else if (setting.img)` branch below and
       draws ONE STORED IMAGE. That used to be an EMPTY mounting — honest, and ugly.
       The composite pass then set a diamond into 131 of those tiles and Stuller's own
       finished photography covers 588 more, so a shopper who picks a blue sapphire now
       sees a white diamond on the last screen before Add to cart. Honest-but-ugly
       became attractive-but-wrong, which is worse: it misrepresents what ships.

       🚨 THE RING'S FIX IS NOT AVAILABLE HERE, AND THAT IS MEASURED, NOT ASSUMED.
       A ring is PARAMETRIC — Stuller hosts a model and `RB.renderUrl` swaps
       `stones/faceted/g_Center` plus the stone's own channel curves. The earring wave
       is flat photography: across 14 bare earring das ids, plain / `+g_Center` /
       `+stones/faceted` / `+obj.recipe=` all return BYTE-IDENTICAL bytes, and
       `obj.recipe=` is the control — it demonstrably recolours a ring and a pendant and
       does nothing here. 0 of 160 `:S` rows carry a render URL. There is nothing to
       recolour, so the only accurate picture of the shopper's stone is its own
       photograph — exactly the position a cabochon is in one wave over.

       ⚠️ ONE FIGURE, NOT TWO. A domed stone in an EARRING build satisfies both reasons;
       inserting a block per reason would put the same photograph on the page twice.
       The caption picks the wave first, because on an earring nothing is rendered at
       all and "not rendered" would be describing a choice that was never available.
       ⚠️ A LEGACY COLOURLESS DIAMOND BUILD GETS NO FIGURE, the same call the domed branch
       makes: the tile already shows approximately that stone in that seat, so a second
       picture is noise. Approved fixed illustrations always retain the original
       stone photo on review. `RB.isColourlessDiamond` is the canonical test and it reads the
       COLOUR GRADE, never the species — a black opaque diamond is a Diamond and is not
       what any of these tiles show. One implementation, in the engine, shared with
       `RB.defaultSideStone`.
       ⚠️ NO CLAIM ABOUT WHAT THE TILE SHOWS. 129 of the 331 mountings show no stone at
       all, and nothing client-side can tell a composited tile from a bare one — there
       is deliberately no marker on the media. So the caption says only that the setting
       above cannot show YOUR stone, which is true of a diamond tile and a bare one. */
    var earring = RB.earringPreview(build, stone);
    // A fixed-photo ring (689651, owner 2026-09-28) takes the earring treatment, but only when its photograph is there:
    // without one the earring words below ("earring mountings are photographed") would describe the wrong piece.
    var photoWave = RB.kind(build) === 'earring' || !!(earring && RB.fixedPhotoRing && RB.fixedPhotoRing(build));
    var wrongStone = photoWave && stone && (earring || !RB.isColourlessDiamond(stone));
    /* 🚨 REMOVE BEFORE INSERTING, BECAUSE THIS FIGURE IS A SIBLING OF THE STAGE.
       `pageReview` re-renders IN PLACE — it looks `stage` up out of the existing DOM —
       and `stage.innerHTML = ''` clears the stage's CHILDREN, not its siblings. So
       every pass would add another copy of the photograph below the last one. It has
       not bitten yet only because the first, synchronous pass runs before the stone
       resolves, so `domed` is false and nothing is inserted; the moment a build takes
       a third pass with the stone already in hand (a side-stone resolve, the targeted
       repaint) the page grows a duplicate. Latent for the domed branch, reachable for
       the earring one, which fires on most earring builds rather than on 178 stones. */
    Array.prototype.forEach.call(
      (stage.parentNode || root).querySelectorAll('.rb-domeshot'),
      function (n) { n.parentNode.removeChild(n); });
    var domeShot = null;
    if ((domed || wrongStone) && stone && stone.img && stage.parentNode) {
      domeShot = el('figure', { class: 'rb-detail__shot rb-domeshot' }, [
        el('img', { src: stone.img, alt: stone.title || 'Your gemstone',
                    loading: 'lazy', draggable: 'false' }),
        el('figcaption', {
          // Says what the picture IS and why the piece above does not show it.
          // A cabochon has no facets for a render to bend light through, so the ring
          // is drawn with an uncoloured stone rather than a faceted lie; an earring
          // mounting is a photograph and was never drawn at all.
          text: 'Your ' + (stone.species || 'gemstone').toLowerCase()
                + (photoWave
                   ? (earring ? ' — original stone photograph' : ' \u2014 earring mountings are photographed, so the setting above')
                     + (earring ? '' : ' cannot show your stone')
                   : ' \u2014 cabochons are shown as photographed, not rendered') })
      ]);
      // Directly after the stage, so it reads as "and here is the actual stone" —
      // ahead of the angle bar, the same slot `.rb-hand` takes.
      stage.parentNode.insertBefore(domeShot, stage.nextSibling);
    }
    // A fixed-photo ring's SECOND stone gets its own photograph too (owner option A 2026-09-28: "the shopper's own stone
    // photos"), in the same figure and words as the centre's, right after it. Only beside the centre's figure.
    var _second = root.__sideStone || null;
    if (domeShot && earring && RB.fixedPhotoRing && RB.fixedPhotoRing(build) && _second && _second.img) {
      domeShot.parentNode.insertBefore(el('figure', { class: 'rb-detail__shot rb-domeshot' }, [
        el('img', { src: _second.img, alt: _second.title || 'Your gemstone', loading: 'lazy', draggable: 'false' }),
        el('figcaption', { text: 'Your ' + (_second.species || 'gemstone').toLowerCase() + ' — original stone photograph' })
      ]), domeShot.nextSibling);
    }
    var viewer = null;
    if (earring) {
      earringStage(stage, angleBar, earring);
    } else if (angles.length) {
      /* ONE implementation of "which thumbnail looks selected", used by the
         thumbnail clicks, by the hand toggle and by the viewer's own drag. The
         hand button sits at index `angles.length` on the same bar, which is why
         this takes a bar index rather than an angle index. */
      var markAngle = function (i) {
        angleBar.querySelectorAll('.rb-angle').forEach(function (b, j) {
          b.setAttribute('aria-pressed', String(j === i));
        });
      };
      viewer = RB.mountAngleViewer(stage, angles, {
        label: RB.settingName(setting.title),
        style: build.style,          // for RB.styleScale — the pendant framing fix
        onChange: markAngle          // a drag or an arrow key moves the strip too
      });
      angleBar.innerHTML = '';
      /* ⚠️ THE HANDLERS ARE ATTACHED BELOW, NOT HERE, AND THAT IS DELIBERATE.
         `RB.el` binds an `onXxx` key with addEventListener, so assigning
         `b.onclick` afterwards ADDS a second listener rather than replacing the
         first — both would fire, the old one knowing nothing about the hand view,
         and the two would agree often enough to look fine. One handler, defined
         once, after the whole bar exists. */
      angles.forEach(function (a, i) {
        angleBar.appendChild(el('button', {
          class: 'rb-angle', type: 'button', 'aria-pressed': String(i === 0),
          title: RB.angleLabel(a.angle)
        }, [el('img', { src: a.url, alt: RB.angleLabel(a.angle), loading: 'lazy' })]));
      });
      /* ─────────────────────────────────────────── SEE IT ON A HAND ─────
         One more thumbnail on the same bar, because it IS another view of the
         same ring rather than a separate feature. The cutout URL comes from
         RB.renderUrl — the same objset and the same centre-stone curve the five
         angles already use — with only the format appended, so a hand view can
         never disagree with the stage about what was built.

         🚨 THE CONTROL IS NOT RENDERED WHEN IT CANNOT BE HONOURED. RH.mount
         returns null when the plates, the aperture asset or this seat's aperture
         are missing, and then no button appears at all. A route advertised and
         not honoured is the failure this repo keeps paying for — the pearl that
         offered "Set This Stone Into a Ring" and opened an empty grid. */
      var handHost = null;
      if (window.RH) {
        handHost = el('div', { class: 'rb-hand', hidden: true });
        stage.parentNode.insertBefore(handHost, angleBar);
        var mounted = RH.mount(handHost, build, function (das) {
          return RB.renderUrl(das, build.metal, RH.RENDITION,
                              RB.objsFor(build.style, build.seat),
                              stone && stone.curve, null,
                              typeof RB.accentCurve === 'function' ? RB.accentCurve(build.accentStone || build.accent) : null) +
                 '&fmt=' + RH.FMT;
        });
        if (!mounted) {
          handHost.remove();
          handHost = null;
        }
      }
      /* Both directions of the toggle, so the five angle buttons and the hand
         button are one exclusive group rather than two that can both look on. */
      var setView = function (idx) {
        /* display, not [hidden]: .rb-stage sets `position: relative` and an
           aspect-ratio, and [hidden] is one `display:` declaration away from
           being overridden by either. */
        stage.style.display = idx >= 0 ? '' : 'none';
        if (handHost) handHost.hidden = idx < 0 ? false : true;
        /* 🚨 ASK THE VIEWER, NEVER TOGGLE ITS IMAGES BEHIND IT. This used to
           walk `stage.querySelectorAll('img')` and set `.on` directly, which
           still "works" — the images are right there — but the viewer keeps its
           own current index for the drag, the keyboard and the aria label. Set
           the class from outside and the next drag jumps back to wherever the
           viewer still thought it was. `show()` also drops any zoom, so
           switching view never leaves the next angle magnified and panned to a
           corner of a ring it is not showing. */
        if (idx >= 0 && viewer) viewer.show(idx);
        /* Leaving the hand view has to hand focus back to something real: the
           stage is `display:none` while the hand is up, and a focused element
           that gets hidden drops focus to <body>, sending the next Tab to the
           top of the page. */
        if (idx >= 0 && document.activeElement === document.body) stage.focus({ preventScroll: true });
        markAngle(idx < 0 ? angles.length : idx);
      };
      angleBar.querySelectorAll('.rb-angle').forEach(function (b, i) {
        b.addEventListener('click', function () { setView(i); });
      });
      if (handHost) {
        angleBar.appendChild(el('button', {
          class: 'rb-angle rb-angle--hand', type: 'button', 'aria-pressed': 'false',
          title: 'See it on a hand',
          onclick: function () { setView(-1); }
        }, [el('span', { class: 'rb-angle__label', text: 'On hand' })]));
      }
    } else if (setting) {
      var own = ownPhoto(setting, build.metal);     // the chosen metal's own photograph (ownPhoto, above)
      if (own) stage.appendChild(el('img', { src: own, alt: setting.title, class: 'on' }));
      else earringStage(stage, angleBar, UNAVAILABLE);
    }

    // 🚨 MULTIPLY BY THE PAIR QUANTITY OR THE REVIEW PAGE UNDER-QUOTES BY HALF.
    // A Shopify variant price is per UNIT, and Stuller sells an earring mounting
    // as ONE earring — so `addToCart` posts quantity 2 for the earring wave while
    // `sv[1]` and `stone.price` are still single-unit numbers. Adding them raw
    // would show a customer $X and charge them $2X at the cart: the same class of
    // silent under-quote as the unresolved-stone bug above, and it appears the
    // day the earring wave goes live rather than being introduced later.
    // 1 for rings and pendants, so both are untouched.
    var qty = RB.pairQty(build);
    var settingPrice = (sv ? sv[1] : 0) * qty;
    // `stone` is declared above, before the render — see the note there.
    var stonePrice = (stone ? stone.price : 0) * qty;
    // The shard is still in flight. pageReview runs once synchronously and again
    // when it lands, and on that first pass a build WITH a stone looks exactly
    // like a build without one — so the page would state "No center stone chosen"
    // and a total that is the setting alone. Both are wrong rather than merely
    // early, and the wait is up to seven seconds when the fallback has to walk
    // every shard. Say "loading" and quote nothing until we can quote it all.
    var loadingStone = !!build.stone && !root.__stoneResolved;
    summary.innerHTML = '';
    summary.appendChild(el('div', { class: 'rb-line' }, [
      el('span', {}, [
        el('span', { text: RB.settingName(setting.title) }),
        el('span', { class: 'rb-line__sub', text: build.metal + ' · ' + RB.seatLabel(build.seat) +
          (build.accent && build.accent !== 'None' && !acc ? ' · ' +
            // a coloured accent is lab-grown and says so (colored pavé, owner 2026-09-25)
            (typeof RB.accentCurve === 'function' && RB.accentCurve(build.accent)
              ? 'Lab-grown ' + String(build.accent).toLowerCase() : build.accent) + ' accents' : '') })
      ]),
      el('span', { class: 'rb-line__amt', text: money(settingPrice) })
    ]));
    summary.appendChild(el('div', { class: 'rb-line' }, [
      el('span', {}, [
        el('span', { text: stone ? stone.title
                                 : (loadingStone ? 'Loading your gemstone…' : 'No center stone chosen') }),
        el('span', { class: 'rb-line__sub', text: stone
          ? ['Center stone', stone.lab && stone.cert ? stone.lab + ' ' + stone.cert : null,
             stone.l ? stone.l.toFixed(2) + ' × ' + (stone.w || stone.l).toFixed(2) + ' mm' : null]
              .filter(Boolean).join(' · ')
          : (loadingStone ? 'One moment' : 'Go back to step 2') })
      ]),
      el('span', { class: 'rb-line__amt', text: stone ? money(stonePrice) : (loadingStone ? '…' : '—') })
    ]));

    /* ── SIDE STONES ────────────────────────────────────────────────────────
       Rendered only when the chosen mounting actually has a side seat for the
       chosen centre seat. `RB.sideSeat` returns null for every style we sell
       today (28,260 onboarded SKUs, 0 side locations — all our three-stone
       designs are the Semi-Set SKU), so this whole block is inert until a
       MOUNTING SKU is onboarded, and the review page is unchanged until then.

       ⚠️ NOT A SEPARATE STEP. The owner's brief was a switch "when available",
       not a fourth step every shopper walks through — so the choice lives on the
       line it prices, the way the chain picker sits on a pendant page. */
    var sideSeat = RB.sideSeat(build.style, build.seat);
    // ONE stone on a second-stone design: the owner's words on this line and in the error line below
    // (RB.secondStone; guarded against the engine's previous copy)
    var sideSecond = !!(sideSeat && RB.secondStone && RB.secondStone(build.style, sideSeat) && qty === 1);
    var sideStone = root.__sideStone || null;
    // never print the seat's millimetres beside a stone the seat cannot hold
    if (sideSeat && sideStone && !RB.sideFits(build, sideStone)) sideStone = null;
    if (sideSeat) {
      // the chosen stone's own shape ("Radiant 5.00 × 3.00 mm"), or every shape the seat takes (owner 2026-10-06)
      var sideWord = RB.sideSeatLabel ? RB.sideSeatLabel(sideSeat.spec, sideStone, build.style, sideSeat.set) : RB.seatLabel(sideSeat.spec);
      var sideQty = (sideSeat.n || 2) * qty;
      var sidePrice = (sideStone ? sideStone.price : 0) * sideQty;
      var pick = el('a', {
        class: 'rb-line__change',
        href: RB.href(RB.sidePage(build), build, { for: 'side' }),
        text: sideStone ? 'Change' : (sideSecond ? 'Choose a second stone' : 'Choose side stones')
      });
      summary.appendChild(el('div', { class: 'rb-line' }, [
        el('span', {}, [
          el('span', { text: sideStone ? sideStone.title : (sideSecond ? 'Second stone' : 'Side stones') }),
          el('span', { class: 'rb-line__sub', text: sideSecond
            // one stone, so no count and no "matched set" (owner Q6): the line says what it is
            ? (sideStone ? 'Second stone · ' + sideWord
                         : sideWord + ' — required')
            : sideStone
            // The quantity is stated because it is what the shopper is buying and
            // what they are charged for — `n` is 2 on most designs but 1 on ten of
            // them and 4 on two, so a hardcoded "pair" would be wrong on twelve.
            ? [sideQty + ' × ' + sideWord, 'matched set'].join(' · ')
            /* ⚠️ "REQUIRED", NOT "OPTIONAL" — AND THE WORD WAS A FALSE CLAIM ABOUT
               THE PRODUCT, not a tone choice. This mounting is Stuller's bare SKU
               (`SetWith` empty on 24 of 24 sampled variants), so a ring bought
               without side stones arrives with two visible holes. */
            : sideQty + ' × ' + sideWord + ' — required' }),
          pick
        ]),
        el('span', { class: 'rb-line__amt',
                     text: sideStone ? money(sidePrice) : '—' })
      ]));
    }
    /* ── ACCENT STONES ── (owner option 1, 2026-11-03) on a design with a menu: the chosen line at its charge, or the
       design's diamond accents as included, each with the way to the Accent stones step. In the part order of the cart. */
    var accentPrice = acc ? acc.charge * qty : 0;
    if (acc || (RB.kind(build) === 'ring' && typeof RB.hasAccentMenu === 'function' && RB.hasAccentMenu(build))) {
      summary.appendChild(el('div', { class: 'rb-line' }, [
        el('span', {}, [
          el('span', { text: acc ? RB.accentName(acc) + ' accents'
            : ((build.accent === 'Natural' || build.accent === 'Lab-Grown') ? build.accent + ' diamond' : 'Diamond') +
              ' accents' }),
          el('span', { class: 'rb-line__sub', text: acc
            ? [acc.stones * qty + ' stones', acc.cut, acc.grade, acc.treatment || null].filter(Boolean).join(' · ')
            : 'Included with the setting' }),
          el('a', { class: 'rb-line__change',
                    href: RB.href(RB.pages.settings, build, { configure: 1, 'for': 'accent', from: 'review' }),
                    text: acc ? 'Change' : 'Choose gemstone accents' })
        ]),
        el('span', { class: 'rb-line__amt', text: acc ? money(accentPrice) : 'Included' })
      ]));
    }

    /* ── A MATCHING CHAIN ───────────────────────────────────────────────────
       PENDANT WAVE ONLY. The picker itself is `snippets/matching-chain.liquid`,
       rendered into the summary column by the section — the SAME panel a finished
       pendant page shows, running the SAME gate. This block only feeds it the
       pendant descriptor and reads back what was chosen.

       🚨 THE GATE IS NOT REIMPLEMENTED HERE, AND THAT IS THE POINT. `fits()` already
       exists twice — `chain_fit.py` and `matching-chain.js` — and that duplication is
       deliberate, bounded and CHECKED (`verify_chain_fit.py` parses the JS and fails
       on drift). A third copy in this file would be none of those things. We borrow
       `window.SRChainFit` exactly the way this builder already borrows `SRScale.make`
       and `SRCompare.sync`.

       ⚠️ GUARDED ON `window.SRChainFit` EVERYWHERE. The panel is an add-on: if its
       asset is stale, absent, or the wave is not pendant, every branch here is inert
       and the review page is exactly what it was before. A chain that fails to load
       must never take Add to cart down with it. */
    var chainMount = root.querySelector('[data-rb-chain] matching-chain');

    /* 🚨 ONE RULE, TWO CALLERS — the first paint and the `sr:chain` repaint. The
       repaint used to ask `root.querySelector('.mchain__opt')`, a node the INLINE
       list renders and the DRAWER does not, so switching the builder to the drawer
       would have printed "Not stocked in this metal" under a panel offering twenty.
       ⚠️ DECLARED HERE, IN THE SCOPE BOTH SHARE — not inside the first paint's `if`.
       A function declaration inside a block is block-scoped, so the listener threw
       `chainPoolCount is not defined` and ABORTED PART-WAY: the line's name became
       "No chain" while its description, price and the order total kept the removed
       chain's values. Caught in a browser on the flip, never by a source read — the
       call site looks correct from either end. */
    function chainPoolCount() {
      if (!chainMount || !window.SRChainFit) return 0;
      try {
        var descs = JSON.parse(chainMount.querySelector('script.mchain__pendants').textContent);
        var rows = JSON.parse(chainMount.querySelector('script.mchain__chains').textContent);
        return (descs && descs[0]) ? window.SRChainFit.grouped(descs[0], rows).length : 0;
      } catch (e) { return 0; }
    }

    /* ⚠️ CHAIN PRICES ARE IN CENTS AND EVERY OTHER PRICE ON THIS PAGE IS IN DOLLARS.
       The chain rows come from Liquid (`cv.price`), which is cents; the shard's
       `sv[1]` and `stone.price` are float dollars, and `RB.money` takes dollars
       despite its parameter being named `cents`. Mixing the two is not a rounding
       error — it is the 2026-08-06 defect that scored an $11,625 diamond below a
       $545 sapphire, and here it would quote a $285 chain as $28,500. Converted at
       the ONE place a chain price enters the arithmetic. */
    function chainTotal() {
      if (!chainMount || !window.SRChainFit) return 0;
      var c = window.SRChainFit.chosen();
      return c ? c.p / 100 : 0;
    }

    // IS A CHAIN CHOSEN — which is not "does it cost anything" (see the final-sale note below).
    function chainPicked() {
      return !!(chainMount && window.SRChainFit && window.SRChainFit.chosen());
    }

    if (chainMount && window.SRChainFit) {
      /* THE PENDANT DESCRIPTOR, in the shape `matching-chain.js` already reads:
         {i, k, m, c, cl, g}. k is the exact resolved SKU, never a style default. Composed HERE because Liquid cannot — the mounting, metal
         and seat live in the query string and `request.query_string` is not a real
         Liquid property (2026-08-17).

         ⚠️ `c` IS THE BAIL'S MINOR AXIS and comes off the shard's `bail` column,
         which `build_builder_assets.bail_for` derives through `chain_fit.parse_passage_mm`.
         `setting_specs`' own numeric `bail` is the MAJOR axis of the same string and
         differs on 89 of 116 styles — feeding that here would offer 963 chains that
         cannot physically thread, each one a real chain at a real price in the right
         metal, i.e. a defect with no visible symptom until the parcel arrives.

         ⚠️ `g` IS LOAD-BEARING, NOT DECORATION. Gate 4 refuses a HOLLOW chain under a
         pendant over 2.0 g or with an unknown weight. Zero is the data contract's
         unknown sentinel, not a claim of weightlessness: the gate requires a known
         positive weight before offering a hollow chain.

         `i` is a build signature rather than a variant id: matching-chain.js clears the
         chosen chain when `i` changes, which is exactly the behaviour wanted if the
         mounting or metal is ever re-resolved underneath us. */
      var chainDesc = {
        i: [build.style, build.metal, build.seat, build.accent].join('|'),
        k: (sv && sv[3]) || '', // exact chosen mounting SKU; old/missing data offers no chain
        m: build.metal || '',
        c: (typeof setting.bail === 'number' && setting.bail > 0) ? setting.bail : 0,
        cl: setting.bailLabel || '',
        g: (typeof setting.gram === 'number' && setting.gram > 0) ? setting.gram : 0
      };
      var descNode = chainMount.querySelector('script.mchain__pendants');
      if (descNode) {
        var next = JSON.stringify([chainDesc]);
        // Only on a real change. pageReview runs at least twice (sync, then again
        // when the shard lands) and `refresh()` forces a repaint, so writing
        // unconditionally would re-render the panel under the shopper's cursor —
        // collapsing an open list they were reading. Same reasoning as `lastSig`.
        if (descNode.textContent !== next) {
          descNode.textContent = next;
          window.SRChainFit.refresh();
        }
      }
    }

    /* The chain's own summary line. Read from `SRChainFit.chosen()` rather than kept
       in a variable here: the panel owns that state, and a second copy of it in this
       file is how the line and the cart come to disagree. */
    var chainLine = null;
    if (chainMount && window.SRChainFit) {
      var chosenChain = window.SRChainFit.chosen();
      /* ⚠️ "Optional — choose one above" IS AN INSTRUCTION, so it must only appear
         where it can be followed. On PLATINUM nothing fits — we stock no platinum
         chain, which is 89 of this wave's 463 (style x metal) cells — and the panel
         directly above correctly says so, while this line was still telling the
         shopper to pick one from a panel offering nothing. Asking `SRChainFit.grouped`
         rather than counting rendered DOM nodes: the panel paints asynchronously, so
         a node count is a race and would read "nothing fits" on a slow first pass over
         a metal that has fourteen chains. */
      var chainPool = chainPoolCount();
      chainLine = el('div', { class: 'rb-line', 'data-rb-chainline': '' }, [
        el('span', {}, [
          el('span', { text: chosenChain ? chosenChain.t : 'No chain' }),
          el('span', { class: 'rb-line__sub', text: chosenChain
            ? ['Matching chain', chosenChain.l, chosenChain.w ? chosenChain.w + ' mm' : null]
                .filter(Boolean).join(' · ')
            // ⚠️ "OPTIONAL" IS TRUE HERE AND WAS A FALSE CLAIM ON THE SIDE-STONE LINE.
            // The distinction is the product, not the tone: a mounting with empty side
            // seats cannot be worn, a pendant without a chain is a finished pendant.
            : (chainPool ? 'Optional — choose one above'
                         : 'No compatible chain available') }),
        ]),
        el('span', { class: 'rb-line__amt',
                     text: chosenChain ? money(chosenChain.p / 100) : '—' })
      ]);
      summary.appendChild(chainLine);
    }

    /* THE BASE TOTAL — everything except the chain, which the shopper can change
       without leaving this page. Kept on `root` so the repaint below can add the
       chain to it without re-deriving prices that are already on screen. */
    /* ── RING SIZING ── the charge for the size chosen below, on its own line like every other part, and in the total.
       Drawn hidden and filled by `paintSizingLine`, which the size menu calls again on every change. */
    if (RB.isSized(build)) {
      summary.appendChild(el('div', { class: 'rb-line', 'data-rb-sizingline': '', hidden: 'hidden' }, [
        el('span', {}, [
          el('span', { text: 'Ring sizing' }),
          el('span', { class: 'rb-line__sub', text: '' })
        ]),
        el('span', { class: 'rb-line__amt', text: '' })
      ]));
    }
    // `__partsTotal` is every part; `__baseTotal` adds the sizing charge, and the chain repaint adds the chain to it.
    root.__partsTotal = settingPrice + stonePrice + accentPrice +
      (sideSeat && sideStone ? sideStone.price * (sideSeat.n || 2) * qty : 0);
    root.__baseTotal = root.__partsTotal + sizingTotal(build);

    summary.appendChild(el('div', { class: 'rb-total' }, [
      el('span', { text: RB.pieceCopy('Your ring', build) }),
      // ⚠️ THE SIDE STONES ARE IN THE TOTAL. The cart's own total was summing two
      // terms and under-quoting a three-stone build by the price of the sides;
      // quoting it correctly HERE and wrongly there — or the reverse — is the same
      // defect one screen earlier, and this is the number the shopper agrees to.
      // ⚠️ AND SO IS THE CHAIN, for the identical reason — it is a line the cart
      // will charge for. `chainTotal` is 0 on every wave but pendant.
      el('span', { class: 'rb-total__amt', 'data-rb-total-amt': '',
        text: loadingStone ? '…' : money(root.__baseTotal + chainTotal()) })
    ]));
    paintSizingLine(root, build);

    /* ── THE CHAIN CHANGES WITHOUT LEAVING THIS PAGE ────────────────────────────
       🚨 SETTING STATE WITHOUT REPAINTING WHAT READS IT IS A FIX THAT CHANGES
       NOTHING — the exact defect the side-stone step bar shipped (globals set, bar
       built before them, step 3 reading "Selected" over a total $330 short). The
       shopper picks a chain in a panel this function does not own, so nothing here
       re-runs on its own.

       ⚠️ A TARGETED REPAINT, NOT `pageReview()` AGAIN. Re-rendering the page would
       rebuild the angle viewer and throw away the frame the shopper had dragged to,
       on every chain click. Only the two numbers the chain can move are rewritten.

       ⚠️ WIRED ONCE, ON `root`, NOT ON THE SUMMARY. pageReview replaces the summary's
       innerHTML on its second pass, so a listener scoped to a node inside it would be
       detached and silently stop working — and everything it updates is looked up at
       EVENT time for the same reason. This is the `cta.__rbWired` lesson, one element
       out. */
    if (chainMount && window.SRChainFit && !root.__rbChainWired) {
      root.__rbChainWired = true;
      document.addEventListener('sr:chain', function () {
        var c = window.SRChainFit.chosen();
        var line = root.querySelector('[data-rb-chainline]');
        if (line) {
          var nameEl = line.querySelector('span > span');
          var subEl = line.querySelector('.rb-line__sub');
          var amtEl = line.querySelector('.rb-line__amt');
          if (nameEl) nameEl.textContent = c ? c.t : 'No chain';
          if (subEl) {
            subEl.textContent = c
              ? ['Matching chain', c.l, c.w ? c.w + ' mm' : null].filter(Boolean).join(' · ')
              // ⚠️ THE SAME TWO-WAY COPY AS THE FIRST PAINT. Hardcoding the optional
              // wording here would put "choose one above" back the moment a shopper
              // cleared a chain — the repaint quietly undoing the render's own rule,
              // which is the shape of defect this file has hit twice before.
              // Asks the GATE, not the DOM: `.mchain__opt` only exists in the inline
              // list, so counting it printed "Not stocked" under a full drawer.
              : (chainPoolCount() ? 'Optional — choose one above'
                                  : 'No compatible chain available');
          }
          if (amtEl) amtEl.textContent = c ? money(c.p / 100) : '—';
        }
        // THE FINAL-SALE NOTE'S CHAIN SENTENCE, repainted from the same `chosen()` answer as the row above.
        var saleEl = root.querySelector('[data-rb-chain-returnable]');
        if (saleEl) saleEl.textContent = c ? 'Your matching chain can still be returned. ' : '';
        var totalEl = root.querySelector('[data-rb-total-amt]');
        // Never overwrite the loading placeholder with a total we cannot yet quote:
        // `__baseTotal` is only meaningful once the stone has resolved.
        if (totalEl && typeof root.__baseTotal === 'number' && !root.__stonePending) {
          totalEl.textContent = money(root.__baseTotal + (c ? c.p / 100 : 0));
        }
        // …and the button that quotes it, unless the button is saying something else right now ("Adding…").
        var ctaNow = root.querySelector('[data-rb-cta]');
        if (ctaNow && /^Add to cart/.test(ctaNow.textContent || '')) ctaNow.textContent = ctaLabel(root);
      });
    }
    /* 🚨 THE CTA WAITS ON THE SIDES. `RB.addToCart` refuses this build anyway — that
       is the gate a shared URL cannot walk past — but a button that looks live and
       then rejects is a dead end at the last screen, which is the exact shape of the
       `accent=None` defect (2026-08-17). Say it before they press.
       ⚠️ `__sideResolved` is what separates "no side chosen" from "still loading";
       `build.side` alone would flash the warning on every reload of a complete
       build. */
    /* ⚠️ A RESOLVED STONE THAT DOES NOT FIT COUNTS AS MISSING. The resolve chain
       drops it and re-defaults, so this is belt-and-braces for the one render that
       can happen between "resolved" and "dropped" — the gate must never be live over
       a stone the seat cannot hold. */
    /* 🚨 A CARRIED SIDE IS "LOADING" UNTIL IT RESOLVES, AND THE GATE HOLDS WHILE IT
       DOES — the `loadingStone` discipline the centre stone already has. The centre
       resolves first on every run measured, so without this the CTA went live over an
       unresolved side and failed only on the click (Codex, 2026-09-02). A misfit never
       needs its own test here: the resolve chain normalises the row BEFORE it is
       assigned to `root.__sideStone`, so by the time `__sideResolved` flips the side is
       either a fitting stone or absent. (An earlier `sideMisfit` term read the same
       already-normalised row and could never be true — removed rather than kept as a
       guard that cannot fire.) */
    var sideLoading = !!(sideSeat && build.side && !root.__sideResolved);
    // a vid that resolved to NO row is not a side either (the chain drops it; this is the
    // belt for the render between "resolved" and "dropped")
    var sideVanished = !!(sideSeat && build.side && root.__sideResolved && !root.__sideStone);
    var sideMissing = !!sideSeat && (!build.side || sideLoading || sideVanished);
    /* ⚠️ THE ELSE BRANCH IS NOT OPTIONAL. `pageReview` re-renders in place when the
       default side stone resolves, and this element is OUTSIDE the summary it
       rebuilds — so a warning shown on the first pass survived the fix that made it
       untrue, and the completed ring carried "Choose them and your ring is ready to
       order" over a live Add to cart. A message that can be shown must be able to be
       taken back. */
    var errEl = root.querySelector('[data-rb-error]');
    if (errEl) {
      if (sideMissing && !sideLoading) {
        errEl.hidden = false;
        errEl.textContent = sideSecond
          ? 'This setting is made with a second stone. Choose it and your ring is ready to order.'
          : 'This setting is made with ' + ((sideSeat.n || 2) * qty) +
          ' side stones. Choose them and your ring is ready to order.';
      } else if (/side stones\. Choose them|second stone\. Choose it/.test(errEl.textContent || '')) {
        // only OUR message is cleared — a genuine error from elsewhere must survive
        errEl.hidden = true;
        errEl.textContent = '';
      }
    }
    // and the button cannot be live over a total we are not showing
    if (cta) {
      /* ⚠️ AND NOT OVER "No center stone chosen". The line above says it plainly and
         the button was live anyway, so pressing it produced an error instead of the
         reason (Codex, 2026-09-02). `RB.addToCart` still refuses — this is the honest
         face on the same gate. */
      cta.disabled = !!loadingStone || sideMissing || !stone || engraveBlocked(root, build);
      cta.textContent = (loadingStone || sideLoading) ? 'Loading…' : ctaLabel(root);
    }

    /* ---- ring size: REQUIRED, and until now never asked for ---------------
       RB.addToCart has always sent `build.size || 'To be confirmed'` and nothing
       ever set build.size, so every custom ring would have been ordered with no
       finger size. The list is per style (see RB.ringSizes) and the choice goes
       into the URL like every other part of the build, so a shared link carries
       the size too. */
    var sizes = RB.ringSizes(build.style);
    // announced when shown, and tied to the select by id (Codex, 2026-09-02)
    var sizeErr = el('p', { class: 'rb-size__err', hidden: 'hidden', id: 'rb-size-err', role: 'alert',
      text: 'Choose a ring size first.' });
    if (sizes && sizes.length) {
      var sel = el('select', { class: 'rb-size__sel', id: 'rb-size',
        'aria-describedby': 'rb-size-help rb-size-err' });
      sel.appendChild(el('option', { value: '', text: 'Select a size' }));
      sizes.forEach(function (s) {
        var o = el('option', { value: String(s), text: sizeOptionText(build, s) });
        // a size nothing can charge for is listed, and cannot be chosen (RB.sizingFor fails closed)
        if (typeof RB.sizingFor === 'function' && RB.sizingFor(build, s).kind === 'unavailable') o.disabled = true;
        if (build.size && String(build.size) === String(s)) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        build.size = sel.value || null;
        sizeErr.hidden = true;
        repaintSizing(root, build);
        // keep the URL authoritative — the build must stay shareable
        try {
          var u = new URL(location.href);
          if (build.size) u.searchParams.set('size', build.size);
          else u.searchParams.delete('size');
          history.replaceState(null, '', u);
        } catch (e) {}
      });
      summary.appendChild(el('div', { class: 'rb-size' }, [
        el('label', { for: 'rb-size', class: 'rb-size__lbl', text: 'Ring size (US)' }),
        sel,
        sizeErr,
        el('p', { class: 'rb-size__help', id: 'rb-size-help' }, [
          el('span', { text: 'Not sure of your size? ' }),
          el('a', { href: '/pages/contact', style: 'color:inherit;text-decoration:underline;', text: 'Contact us' }),
          el('span', { text: ' before you order and we’ll help you find it.' })
        ])
      ]));
    }

    engravePlace(root, build, summary);   // the engraving box, after the size (owner 2026-10-06)

    // the durability note only appears when there is something worth saying —
    // an "excellent" stone gets no note at all rather than reassurance nobody asked for
    if (stone && stone.wear && stone.wear.indexOf('Excellent') < 0) {
      summary.appendChild(el('div', { class: 'rb-note' }, [
        el('strong', { text: stone.wear + '. ' }),
        el('span', { text: 'This is a softer or more characterful stone — worth knowing before you commit. We are glad to talk it through.' })
      ]));
    }

    /* FINAL SALE, THE LAST THING BEFORE "Add to cart" (owner 2026-09-16: say it before the email).
       The cart card and checkout already carry the same note on the line items; this is the first
       place it appears, while the shopper can still change their mind. Its own sentence, not a rewrite of
       RB.FINAL_SALE (the cart/checkout line copy): there is room here to say it plainly and link the policy.
       returns-final-sale/test_final_sale.py holds both to the same promise.
       ⚠️ A MATCHING CHAIN IS NOT FINAL SALE — it is an unmodified finished chain we also sell on its
       own, so the sentence is added only while one is actually chosen (same rule as the cart card). */
    summary.appendChild(el('div', { class: 'rb-note rb-note--final' }, [
      el('strong', { text: 'Final sale. ' }),
      el('span', { text: 'This piece is made and set to order, so it cannot be returned or exchanged. ' }),
      /* ⚠️ ITS OWN NODE, REPAINTED WITH THE CHAIN (Codex review-mu3kv2k5-rsz7jq). The chain is chosen in a
         panel this function does not own and the `sr:chain` listener repaints in place, so a sentence
         written once here went stale the moment a shopper added or cleared a chain — telling them their
         returnable chain was final sale, or the reverse, on the last screen before they pay. */
      /* ⚠️ PRESENCE, NOT PRICE (Codex review-mu3kz2jn-lmv8tv). This read `chainTotal() > 0`, so a chain
         given away at $0 — a promotion, a complimentary chain, or a price that failed to load — was treated
         as "no chain chosen" and the shopper was told their returnable chain was final sale. The listener
         above already reads presence; both halves now ask the same question. */
      el('span', { 'data-rb-chain-returnable': '',
                   text: chainPicked() ? 'Your matching chain can still be returned. ' : '' }),
      el('a', { href: '/policies/refund-policy', target: '_blank', rel: 'noopener', text: 'Refund policy' })
    ]));

    // WIRE THE CTA EXACTLY ONCE. pageReview runs twice whenever the build has a
    // stone — once synchronously from the dispatcher, then again after
    // resolveStone comes back — and the CTA button is a sibling of the summary,
    // so it survives the innerHTML reset. Two listeners on one node meant one
    // click fired addToCart TWICE: four line items and two _build_ids for one
    // ring. Read the stone from root.__stone at click time rather than closing
    // over it, because on the first pass it is still null.
    if (cta.__rbWired) return;
    cta.__rbWired = true;
    cta.addEventListener('click', function () {
      var chosen = root.__stone || null;
      if (engraveBlocked(root, build)) {
        engraveUnavailable(root, build, root.querySelector('[data-rb-summary]'));
        return;  // a forced click cannot discard saved personalization while its data is unavailable
      }
      // THE SAME CHECK AS ABOVE, AT CLICK TIME. The block above runs on render,
      // and the first render happens before the shard is back — so between the
      // two there is a live button on a build whose stone we have not priced.
      // Everything the click does downstream (the fit test, the total the
      // customer just read) assumes this is not null.
      if (build.stone && !chosen) {
        var boxS = root.querySelector('[data-rb-error]');
        if (boxS) {
          boxS.textContent = root.__stoneResolved
            ? 'We could not find that gemstone — it may have just sold. Choose another and your setting stays with you.'
            : 'Still loading your gemstone — one moment, then try again.';
          boxS.hidden = false;
        }
        return;
      }
      // Look these up at CLICK time, not from the closure: pageReview rebuilds
      // the summary on its second pass, so the nodes captured on the first pass
      // are detached and writing to them would show the customer nothing.
      var errNode = root.querySelector('.rb-size__err');
      var selNode = root.querySelector('.rb-size__sel');
      if (selNode && !build.size) {
        if (errNode) errNode.hidden = false;
        selNode.focus();
        return;
      }
      /* THE SIZING CHARGE THE SHOPPER WAS SHOWN goes with the build, and RB.addToCart refuses any other (owner
         2026-09-17). Each refusal here says what to do rather than failing inside the add. */
      var _sizing = null;
      if (RB.isSized(build)) {
        var boxZ = root.querySelector('[data-rb-error]');
        var sayZ = function (msg) {
          if (boxZ) { boxZ.textContent = msg; boxZ.hidden = false; }
        };
        if (typeof RB.sizingFor !== 'function') {
          // this page is newer than the engine it loaded: a release is still reaching every cache
          sayZ('This page was just updated. Please refresh it to continue — your ring is saved in the address.');
          return;
        }
        if (!selNode) {
          // no data on the page at all is a page mid-release (a cached section); no record for this style is real
          sayZ(typeof window.RB_RING_SIZING === 'undefined'
            ? 'This page was just updated. Please refresh it to continue \u2014 your ring is saved in the address.'
            : 'We are confirming the sizes for this setting. Please contact us to order it.');
          return;
        }
        var zNow = RB.sizingFor(build, build.size);
        if (zNow.kind === 'unavailable') {
          sayZ('Size ' + RB.sizeLabel(build.size) + ' cannot be ordered online for this setting right now. ' +
               'Please contact us and we will help.');
          return;
        }
        if (zNow.kind === 'charge') _sizing = { variantId: zNow.variantId, charge: zNow.charge };
      }
      // LAST LINE OF DEFENCE ON FIT. The grid filters and the seat snaps to the
      // stone, but a build also arrives here from a shared/edited URL, and the
      // seat is what picks the real Stuller mounting SKU. Never post a pair the
      // bench cannot make.
      if (chosen && build.seat && !RB.fits(chosen, build.seat, build.style)) {
        var box0 = root.querySelector('[data-rb-error]');
        if (box0) {
          box0.textContent = 'That gemstone will not sit in this setting size (' +
            RB.seatLabel(build.seat) + ' vs ' + chosen.l.toFixed(2) + ' × ' +
            (chosen.w || chosen.l).toFixed(2) + ' mm). Go back to step 2 and pick ' +
            'a stone for this setting, and we will match the seat for you.';
          box0.hidden = false;
        }
        return;
      }
      cta.disabled = true;
      cta.textContent = 'Adding…';
      /* 🚨 `stone` HAD NEVER BEEN PASSED, AND TWO THINGS DEPEND ON IT.
         This is the ONLY call site of RB.addToCart, and it sent the variant id and
         the title and nothing else — so `opts.stone` was `undefined` on every build
         ever added to this cart. `undefined` is a perfectly good "no stone"
         argument, so nothing threw and nothing looked wrong:

         1. `RB.buildThumb` composed the WHITE-DIAMOND render for the cart, on a
            build whose review stage two lines above was drawing the real colour.
            Caught 2026-08-18 by reading `_rb_img` back off a live cart.
         2. `if (qty > 1 && opts.stone && !RB.pairable(opts.stone))` — addToCart's
            own comment calls this "the last gate before money" for the earring
            wave, and the `opts.stone &&` short-circuit meant it could never fire.
            A one-of-one stone ordered as a pair is an order Stuller cannot fill.

         `chosen` is `root.__stone`, the resolved row — it carries `curve`, `domed`
         and everything `pairable` reads. It is already the value the fit guard
         directly above just tested, so this costs nothing. */
      /* The side stone rides along only when the mounting has a seat for it AND one
         has been chosen. `RB.addToCart` refuses a non-calibrated side outright, so a
         hand-edited URL naming a one-of-one as a side is caught at the last gate
         rather than confirmed and shipped short. */
      var _sideSeat = RB.sideSeat(build.style, build.seat);
      var _sideStone = root.__sideStone || null;
      /* THE CHAIN, READ AT CLICK TIME. Never closed over: the panel owns this state
         and the shopper can change it after any render — a value captured when the
         summary was built is the chain they had, not the one they have. Same rule as
         `chosen` above, and the reason `cta` is wired exactly once.
         ⚠️ `window.SRChainFit &&` — a stale or absent asset must add the pendant
         alone, never fail the whole cart post. */
      if (window.SRChainFit && window.SRChainFit.selectionValid && !window.SRChainFit.selectionValid()) {
        cta.disabled = false;
        cta.textContent = ctaLabel(root);
        var chainError = root.querySelector('[data-rb-error]');
        if (chainError) {
          chainError.textContent = 'The selected chain no longer fits this pendant. Please review your chain choice.';
          chainError.hidden = false;
        }
        window.SRChainFit.refresh();
        return;
      }
      var _chain = (window.SRChainFit && window.SRChainFit.chosen()) || null;
      RB.addToCart(build, {
        stoneVariantId: Number(build.stone),
        stoneTitle: chosen ? chosen.title : '',
        stone: chosen || null,
        side: (_sideSeat && _sideStone)
          ? { variantId: Number(build.side), stone: _sideStone,
              seats: _sideSeat.n || 2 }
          : null,
        chain: _chain,
        sizing: _sizing,
        // the accent stones charge on this page (RB.accentFor at click time; addToCart refuses any other)
        accent: (function () {
          var a = build.accentStone && RB.accentFor ? RB.accentFor(build) : null;
          return a ? { variantId: a.variantId, charge: a.charge } : null;
        })(),
        // the box's words, font and fill, read at click time like the chain (owner 2026-10-06)
        engrave: engraveChoice(root),
        engraveFlow: build.engrave_flow,
        engravePending: engraveBlocked(root, build)
      }).then(function () {
        engraveStore(null);   // in the cart now: the next ring starts with an empty box
        engraveForget(build.engrave_flow);
        location.href = '/cart';
      }).catch(function (e) {
        cta.disabled = false;
        cta.textContent = ctaLabel(root);
        var box = root.querySelector('[data-rb-error]');
        if (box) {
          box.textContent = e.message === 'no stone chosen'
            ? 'Choose a center stone first.'
            : e.code === 'sizing-stale'
              ? 'The ring sizing charge changed since this page loaded. Please refresh the page \u2014 your ring is saved in the address.'
              : e.code === 'accent-stale'
              ? 'The accent stones price changed since this page loaded. Please refresh the page \u2014 your ring is saved in the address.'
              : 'That did not go through — ' + e.message + '. Your build is safe; try again.';
          box.hidden = false;
        }
      });
    });
  }

  /* ------------------------------------------------------------- dispatch */
  document.querySelectorAll('.rb[data-rb-page]').forEach(function (root) {
    var build = RB.read();
    var page = root.getAttribute('data-rb-page');
    var bar = root.querySelector('[data-rb-steps]');
    // A PAGE NO LONGER KNOWS ITS OWN NUMBER. Which half is step 1 depends on how
    // the shopper came in (RB.startedWith), so the page names the half it IS and
    // RB.stepBar assigns the position.
    var activeStep = page === 'settings' ? 'mount'
                   : (page === 'stones' || page === 'stone') ? 'stone' : 'review';
    /* 🚨 THE SIDE PICKER IS NOT STEP 2, AND SAYING SO IS HALF OF WHY THE OWNER READ
       IT AS THE CENTRE-STONE PAGE (2026-08-19). `?for=side` reuses the step-2 grid,
       so the bar marked "Choose a gemstone" as the active step while the shopper was
       choosing an optional upgrade with their centre stone already ticked beside it.
       ⚠️ IT IS ITS OWN STEP NOW (owner decision 2026-08-20), having been a detour off
       review for exactly one day. The reason is not presentation: the mounting ships
       BARE — 24 of 24 sampled ACTIVE variants report `SetWith` empty — so there are
       no default diamonds to decline and the choice is not optional. `RB.stepBar`
       renders a real fourth step for it, and this marks that step rather than review.
       ⚠️ GATED ON A REAL SIDE SEAT, exactly as the grid gates `forSide`. A `?for=side`
       typed onto a solitaire falls through to the ordinary step-2 bar, so the bar and
       the grid can never disagree about which page this is. */
    if (page === 'stones' && new URLSearchParams(location.search).get('for') === 'side' &&
        build.style && build.seat && RB.sideSeat(build.style, build.seat)) {
      activeStep = 'side';
    }
    // STEP 2 DECLARES ITS OWN ORIGIN AND THAT DECLARATION WINS, the same way
    // data-rb-kind beats a stale ?kind=. The Natural/Lab-grown toggle is a link
    // that carries the WHOLE query string across (see ring-builder.liquid), so
    // `origin=lab` rides onto the natural page and stays there — leaving the step
    // bar pointing back at lab from a page showing natural stones. Now that the
    // deep link from a stone product page emits `origin`, that is the common case
    // rather than a curiosity.
    if (page === 'stones') {
      build.origin = root.getAttribute('data-rb-origin') === 'lab' ? 'lab' : 'nat';
    }
    if (bar) RB.stepBar(bar, build, activeStep);
    // Hero copy is Liquid-rendered before `kind` is known — swap the piece word
    // now so a pendant build never reads "Design your ring". Section scope only.
    RB.applyPieceCopy(root.closest('.shopify-section') || root, build);
    // THE ENTRY CHOOSER IS FOR PEOPLE WHO HAVE NOT STARTED. Liquid ships it on
    // every mounting page because it cannot read the query string; once either
    // half is chosen it contradicts the step bar sitting directly above it, so it
    // goes. Removed rather than hidden — it carries two crawlable links, and
    // leaving them in the DOM of a half-built ring is a crawl path into a URL
    // that discards the build.
    if (build.style || build.stone) {
      var entry = root.querySelector('[data-rb-entry]');
      if (entry && entry.parentNode) entry.parentNode.removeChild(entry);
    }
    // the chosen stone lives in a shard; resolve it, then re-render the step bar
    // with its real title and price instead of a placeholder
    if (build.stone) {
      // STEP 1 NOW DEPENDS ON THE STONE TOO — it filters the grid to the settings
      // that can hold it. `__stonePending` is what stops pageSettings drawing all
      // 51 first and cutting to 14 a beat later. `__stoneResolved` is separate and
      // says the answer is IN, null or not: the review page has to tell "still
      // loading" apart from "this stone is gone", and they look identical from
      // `__stone` alone.
      root.__stonePending = true;
      root.__stoneResolved = false;
      RB.resolveStone(build).then(function (st) {
        root.__stonePending = false;
        root.__stoneResolved = true;
        if (st) {
          root.__stone = st;
          window.RB_STONE_TITLE = st.title;
          window.RB_STONE_PRICE = st.price;
          // The mounting half of the bar has carried a thumbnail since it was
          // built; the stone half never did, so a chosen stone read as a line of
          // text beside a picture of the setting.
          window.RB_STONE_IMG = st.img || null;
        } else {
          // 🚨 SAY THE LOOKUP FAILED. `resolveStone` returning null used to leave
          // the bar printing a bare "Selected" — indistinguishable from a stone
          // that resolved fine, on a page whose grid had quietly fallen back to
          // filtering by shape alone. That is how 320 stones with a broken
          // builder button went unnoticed. The shard now covers all three
          // cohorts so this should be rare, but "rare" is exactly the failure
          // that needs to be loud: a stone can also simply have sold.
          window.RB_STONE_MISSING = true;
          window.RB_STONE_TITLE = null;
          window.RB_STONE_PRICE = null;
          window.RB_STONE_IMG = null;
        }
        if (bar) RB.stepBar(bar, build, activeStep);
        if (page === 'review') { try { pageReview(root, build); } catch (e) {} }
        // step 2b renders ONLY from here — a resolve that comes back empty is a
        // real state (the stone just sold) and has to reach its own empty view,
        // so unlike review it must not bail on a null.
        if (page === 'stone') { try { pageStoneDetail(root, build, st); } catch (e) {} }
        if (page === 'settings') { try { pageSettings(root, build); } catch (e) {} }
      });
    } else if (page === 'stone') {
      pageStoneDetail(root, build, null);
    }

    /* THE SIDE STONE RESOLVES ON ITS OWN TRACK. `RB.resolveStone` keys on
       `build.stone`, so the side needs its own lookup — and it deliberately does
       NOT gate the page: a slow or failed side resolve must never hold up a review
       that is already drawn. The CTA is what enforces the requirement, not this.
       ⚠️ The re-render is guarded the same way the centre's is. Without it the
       side line would sit at "—" until something else happened to repaint. */
    /* 🚨 DIAMONDS BY DEFAULT (owner rule 2026-08-20). With no side stone chosen the
       build is filled with the cheapest colourless diamond that fits the seat, so the
       ring is priced and drawn as a classic three-stone from the first time review is
       opened and choosing colour becomes the deliberate swap.
       ⚠️ THE DEFAULT IS WRITTEN INTO THE URL, not held in memory. `RB.addToCart`
       refuses a build whose side seats are unfilled, and every link, share and back
       step reads `build` out of the query string — a default that lived only in a
       variable would price a ring the cart then refused, and would vanish on reload.
       `replaceState` rather than a navigation: the shopper did not ask to move, and a
       reload here would restart the resolve.
       ⚠️ ONLY WHEN THE SEAT HAS ONE. `defaultSideStone` returns null where no
       colourless diamond fits, and then the required step stands and review blocks —
       which is the honest state, not a silent fallback to a black stone. */
    /* ⚠️ THE SAME APPLIER STEP 3 USES. This was a second copy of the rule and the two
       would have drifted into two different defaults for one build — the `chain_fit`
       failure, one screen apart. It stays here as well as on step 3 because a shared
       or bookmarked review link reaches this page without passing through step 3, and
       that link must still price a whole ring. */
    if (page === 'review') {
      RB.ensureDefaultSide(build).then(function (st) {
        if (!st) return;
        root.__sideStone = st;
        root.__sideResolved = true;
        window.RB_SIDE_TITLE = st.title;
        window.RB_SIDE_PRICE = st.price;
        window.RB_SIDE_IMG = st.img || null;
        if (bar) RB.stepBar(bar, build, activeStep);
        try { pageReview(root, build); } catch (e) {}
      });
    }
    if (build.side) {
      RB.resolveStone({ stone: build.side, shape: null, origin: build.origin })
        .then(function (st) {
          /* 🚨 A SIDE THAT NO LONGER FITS IS DROPPED HERE, BEFORE ANYTHING PRINTS IT.
             The centre stone can change after the sides were chosen, and the old
             `side` rides along in the URL. Left alone, the line below printed the
             new seat's millimetres beside the old stone's title and Add to cart was
             live over a ring the bench cannot make (Codex, verified live 2026-09-02).
             Dropping it and re-running the applier gives the seat the shopper
             actually has its own NAMED default — the designed behaviour — or, where
             none fits, the honest "choose them" gate. */
          // drop a vanished stone, drop a misfit — either way THIS seat gets its own default
          if (RB.settleSide(build, st)) {
            return RB.ensureDefaultSide(build);
          }
          return st;
        })
        .then(function (st) {
          /* THE BAR READS GLOBALS, THE SAME WAY THE CENTRE STONE'S HALF DOES. Without
             these the fourth step ticks but shows the raw seat and no price, so the
             one step whose whole job is to be findable is the one with nothing in it.
             ⚠️ Set BEFORE the existing handler re-renders the bar below — two `.then`
             on one promise run in order, so this is deterministic rather than a race. */
          window.RB_SIDE_TITLE = st ? st.title : null;
          window.RB_SIDE_PRICE = st ? st.price : null;
          window.RB_SIDE_IMG = st ? (st.img || null) : null;
          return st;
        })
        .then(function (st) {
          root.__sideStone = st || null;
          root.__sideResolved = true;
          /* 🚨 THE BAR HAS TO BE REDRAWN HERE, NOT ONLY BY THE CENTRE'S HANDLER. The
             two lookups are independent promises and the centre's finishes first on
             every run measured — so the bar was built while `RB_SIDE_TITLE` and
             `RB_SIDE_PRICE` were still unset, and the fourth step rendered a bare
             "Selected" with no price while step 4 quoted a total $330 short of the
             one on screen beside it. Setting the globals without repainting the thing
             that reads them is a fix that changes nothing. */
          if (bar) RB.stepBar(bar, build, activeStep);
          if (page === 'review') { try { pageReview(root, build); } catch (e) {} }
        });
    }
    /* NO-RELOAD FILTERING ON BOTH PICKERS (owner 2026-09-16: "yes, let's proceed with the fixes"). The setting grid
       and the stone grid draw themselves from the address, like gem search, so they use the same helper
       (assets/sr-client-filters.js): a filter writes the address without a page load, and this draws the page again
       from it — the build read again, the step bar, then the grid. The setting detail (`configure=1`) is a view of its
       own and keeps its page loads; so does anything that changes `style` or `for` (see `keep`). */
    var listView = page === 'stones' ||
      (page === 'settings' && !new URLSearchParams(location.search).get('configure'));
    var rail0 = root.querySelector('[data-rb-rail]');
    /* ⚠️ EVERY SCRIPT CURRENT, OR PAGE LOADS AS BEFORE. For ~20 minutes after a release Shopify's caches can pair this
       file with the previous ring-builder.js, ring-builder-stones.js or sr-client-filters.js (see e65ab38). None of
       those can be drawn again in place — the previous drawer marks the rail inert on every draw, so a drawer left
       open would stop answering taps — so the picker goes in place only when each one says it can. */
    var current = !!(window.SRClientFilters && SRClientFilters.builders && RB.redraws &&
      (page !== 'stones' || (RB.mountStones && RB.mountStones.redraws)));
    if (listView && rail0 && current) {
      root.__srClient = SRClientFilters.attach({
        root: root,
        body: rail0,
        grid: root.querySelector('[data-rb-grid]'),
        toolbar: root.querySelector('.rb-toolbar'),
        head: '.rb-rail__head',
        foot: '.rb-rail__apply',
        // The rail is a drawer only where the stylesheet makes it one (`position: fixed`, see RB.syncDrawerA11y).
        drawerOpen: function () {
          return rail0.getAttribute('data-open') === 'true' && getComputedStyle(rail0).position === 'fixed';
        },
        keep: ['configure', 'style', 'for'],
        render: function (token) {
          var next = RB.read();
          if (page === 'stones') next.origin = root.getAttribute('data-rb-origin') === 'lab' ? 'lab' : 'nat';
          if (bar) RB.stepBar(bar, next, activeStep);
          if (page !== 'stones') { pageSettings(root, next); return; }
          return Promise.resolve(pageStones(root, next, root.getAttribute('data-rb-origin') || 'nat', token))
            .then(function () {
              /* 🚨 THE SIDE STONE THE BAR NAMES IS WHATEVER THIS DRAW SETTLED ON. On the side-stone step the grid
                 writes the default (or a re-fitted) side stone into the address as it draws, and the bar names it
                 through the RB_SIDE_* globals, which only the page load used to resolve — so after a filter the bar
                 read "Selected" where a fresh load of the same address names the stone (measured 2026-09-17). Read it
                 again and draw the bar again, before the redraw is reported done, so any change in the bar's height
                 is measured before the view is re-anchored. */
              var settled = RB.read();
              if (activeStep !== 'side' || token.stale()) return;
              if (!settled.side) {
                window.RB_SIDE_TITLE = window.RB_SIDE_PRICE = window.RB_SIDE_IMG = null;
                if (bar) RB.stepBar(bar, next, activeStep);
                return;
              }
              return RB.resolveStone({ stone: settled.side, shape: null, origin: next.origin }).then(function (st) {
                if (token.stale()) return;
                root.__sideStone = st || null;
                root.__sideResolved = true;
                window.RB_SIDE_TITLE = st ? st.title : null;
                window.RB_SIDE_PRICE = st ? st.price : null;
                window.RB_SIDE_IMG = st ? (st.img || null) : null;
                settled.origin = next.origin;
                if (bar) RB.stepBar(bar, settled, activeStep);
              });
            });
        }
      });
    }
    try {
      if (page === 'settings') pageSettings(root, build);
      else if (page === 'stones') pageStones(root, build, root.getAttribute('data-rb-origin') || 'nat');
      else if (page === 'review') pageReview(root, build);
    } catch (err) {
      if (window.console) console.error('[ring-builder]', err);
      var b = root.querySelector('[data-rb-grid]') || root.querySelector('[data-rb-body]');
      if (b) b.innerHTML = '<div class="rb-empty">Something went wrong loading the builder. Please refresh.</div>';
    }
  });
})();
